#import "./fragments.graphql"

query GET_ALL_ROLES {
    GetAllRoles {
        Roles {
            RoleId
            Name
        }
    }
}

query GET_COMPANY_FOR_USER($IsPublic: Boolean = false) {
    GetCompanyForUser {
        CompanyUserRoles {
            CompanyUserRoleId
            User {
                UserId
                #CustomerId
                LanguageCode
            }
            Role {
                RoleId
                Name
            }
            Company {
                CompanyId
                Name
                Email
                LogoPath
                CreatedDateTime
                UpdateDateTime
                AddressLine1
                AddressLine2
                Suburb
                State
                Postcode
                PhoneNumber
                ABN
                Timezone
                Industry
                PrimaryColorTheme
                SecondaryColorTheme
                PaymentOptions {
                    ...PaymentOptionsFragment
                }
                CompanyContacts {
                    Name
                    Email
                    PhoneNumber
                    Type
                }
                CustomFieldsConfigure {
                    ...CompanyCustomFieldConfigureFragment
                }
                IsDueDateView
                IsCalendarView
                IsGroupedATB
                IsSearchCustomFieldsByCheckbox
                NumberOfDaysBeforeRecentCommentTurnedOff
                UsingCustomerWorkflow
                UsingMultipleWorkflow
                LockedDeliveryMethod
                Region
                LanguagePackage {
                    ...LanguagePackageFragment
                }
                Country
                ImportType
                CloudImportType
                ApiImportType
                OrganisationId
                EnableExternalUserTaskAssignment
                EnableMultiFactorAuthentication
                EnableCustomerPortal
                CustomerTitleLabel
                SupportSendNewInvoice
                SupportCashAllocation
                CompanyPaymentPlan {
                    IsEnabled
                    Frequency
                }
                NotificationCustomization {
                    ...CompanyNotificationCustomizationFragment
                }
                InboundEmail
                CommunicationMethod
                CommunicationGroupSettings {
                    CustomerGroup
                    CommunicationStateGroup
                }
                LanguageCode
                EnableBankFileImporting
                UsingCustomBankFileProcessor
                EnableMultiplePaymentPlanOptions
                EnablePaymentBehaviourInsights
                CollectionEmail
                EnableCustomerPortal
                TimeThresholdForCancellingTasksInProgress
                DisableCustomerTickets
                IncludeManualItemsATB
                IncludeRebatesATB
                NotifyDailyImport
                DefaultPaymentPlanFee
                StudentPortalSidebarItems {
                    ...StudentPortalSidebarItemFragment
                }
                CustomerPortalWelcomePageSettings {
                    Title
                    Subtitle
                    Description
                    LogoPath
                    BackgroundImagePath
                    PrimaryColor
                    SecondaryColor
                }
                ReminderAutomation {
                    IsEnabled
                    HourToSend
                }
            }
        }
        SystemConfiguration {
            Environment
            LiveMode
        }
    }
}

query GET_USERS_AND_ROLE_FOR_COMPANY (
    $IsIgnoredCustomerPortalUsers: Boolean = true
    $Name: String
    $Email: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $RoleIds: [String]
    $IsIgnoredCustomerPortalUsers: Boolean = true
) {
    GetUsersForCompany(
        Filter: {
            IsIgnoredCustomerPortalUsers: $IsIgnoredCustomerPortalUsers
            Name: $Name
            Email: $Email
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            RoleIds: $RoleIds
            IsIgnoredCustomerPortalUsers: $IsIgnoredCustomerPortalUsers
        }
    ) {
        CompanyUserRoles {
            CompanyUserRoleId
            User {
                UserId
                GivenName
                FamilyName
                Email
            }
            Role {
                RoleId
                Name
            }
            Company {
                CompanyId
                Name
                LogoPath
            }
        }
    }
}

query GET_USERS_FOR_COMPANY_AUTOCOMPLETE_FILTER (
    $Name: String
    $Email: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $RoleIds: [String]
) {
    GetUsersForCompany(
        Filter: {
            Name: $Name
            Email: $Email
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            RoleIds: $RoleIds
        }
    ) {
        CompanyUserRoles {
            User {
                UserId
                GivenName
                FamilyName
            }
        }
    }
}

query GET_INVOICES_FOR_COMPANY (
    $InvoiceState: String
    $InvoiceNumber: String
    $CustomerId: ID
    $Customer: String
    $CustomerCode: String
    $CustomerCountry: String
    $CustomerState: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $DueDateMin: String
    $DueDateMax: String
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $InvoiceIds: [ID]
    $CompanyId: ID
    $ExcludeInvoices: Boolean
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $IsCloudImportType: Boolean = false
    $IsMultipleWorkflow: Boolean = false
    $UsingCustomerWorkflow: Boolean = false
    $IsBlocked: Boolean
    $PaymentPlanEnabled: Boolean = false
    $CustomerFirstLetter: [String]
    $IsCalendarView: Boolean = false
    $HasPaymentPlan: Boolean
    $InvoiceCode: String
    $ViewAssociatedCustomers: Boolean = false
    $OnHoldUntilMax: String
    $OnHoldUntilMin: String
    $IsVip: Boolean
    $VipUntilMax: String
    $VipUntilMin: String
) {
    GetInvoicesForCompany(
        Filter: {
            InvoiceState: $InvoiceState
            InvoiceNumber: $InvoiceNumber
            CustomerId: $CustomerId
            Customer: $Customer
            CustomerCode: $CustomerCode
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            DueDateMin: $DueDateMin
            DueDateMax: $DueDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            InvoiceIds: $InvoiceIds
            CompanyId: $CompanyId
            ExcludeInvoices: $ExcludeInvoices
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            IsBlocked: $IsBlocked
            CustomerFirstLetter: $CustomerFirstLetter
            HasPaymentPlan: $HasPaymentPlan
            InvoiceCode: $InvoiceCode
            ViewAssociatedCustomers: $ViewAssociatedCustomers
            OnHoldUntilMax: $OnHoldUntilMax
            OnHoldUntilMin: $OnHoldUntilMin
            IsVip: $IsVip
            VipUntilMax: $VipUntilMax
            VipUntilMin: $VipUntilMin
        }
        IsCalendarView: $IsCalendarView
    ) {
        Invoices {
            Id
            CompanyId
            Number
            InvoiceCode
            CreatedDate
            LocalCreatedDate
            DueDate
            LocalDueDate
            OriginalAmount
            AmountOwing
            State
            SettledDate
            LocalSettledDate
            AgedTrialBalanceFromCreate {
                ...AgedTrialBalanceFromCreateFragment
            }
            AgedTrialBalanceFromDue {
                ...AgedTrialBalanceFromDueFragment
            }
            Customer {
                Id
                CustomerCode @skip(if: $IsCloudImportType)
                CompanyName
                DisplayName
                Contacts {
                    ...ContactFragment
                }
                CustomFields {
                    ...CustomFieldFragment
                }
                ConversationLine {
                    ...ConversationLineCommentFragment
                }
                AgedTrialBalance {
                    TotalOverdue
                }
                IsVip
                IsVipExpiryDate
                NewInvoiceSendMode
                CurrentTask @include(if: $UsingCustomerWorkflow) {
                    Id
                    Automation
                    ActionDate
                    Type
                    Workflow {
                        StateName
                        WorkflowName @include(if: $IsMultipleWorkflow)
                    }
                    State
                }
            }
            ConversationLine {
                ...ConversationLineCommentFragment
            }
            CustomFields {
                ...CustomFieldFragment
            }
            Attachments {
                ...AttachmentFragment
            }
            LastCommunication {
                StateName
                SentDateTime
                DeliveryDetails {
                    ...DeliveryDetailFragment
                }
                WorkflowName @include(if: $IsMultipleWorkflow)
            }
            CurrentTask {
                Id
                Automation
                ActionDate
                Type
                Workflow {
                    StateName
                    WorkflowName @include(if: $IsMultipleWorkflow)
                }
                Ticket {
                    TicketOption {
                        Reason
                        CaptureMessage
                        NonBlocking
                    }
                    TicketNumber
                }
                State
                PaymentPlanSchedule @include(if: $PaymentPlanEnabled) {
                    Number
                }
            }
            IsBlocked
            IsBlockedExpiryDate
        }
    }
}

query GET_INVOICES_FOR_COMPANY_AUTOCOMPLETE_FILTER(
    $CompanyId: ID
    $InvoiceState: String
    $InvoiceNumber: String
    $Customer: String
    $CustomerCode: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $DueDateMin: String
    $DueDateMax: String
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $InvoiceIds: [ID]
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
) {
    GetInvoicesForCompany(
        Filter: {
            CompanyId: $CompanyId
            InvoiceState: $InvoiceState
            InvoiceNumber: $InvoiceNumber
            Customer: $Customer
            CustomerCode: $CustomerCode
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            DueDateMin: $DueDateMin
            DueDateMax: $DueDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            InvoiceIds: $InvoiceIds
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
        }
    ) {
        Invoices {
            Number
        }
    }
}

query GET_INVOICES_DETAILS_FOR_COMPANY_AUTOCOMPLETE_FILTER(
    $InvoiceState: String
    $InvoiceNumber: String
    $CustomerId: ID
    $CompanyId: ID
    $Customer: String
    $CustomerCode: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $DueDateMin: String
    $DueDateMax: String
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $InvoiceIds: [ID]
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
) {
    GetInvoicesForCompany(
        Filter: {
            InvoiceState: $InvoiceState
            InvoiceNumber: $InvoiceNumber
            CustomerId: $CustomerId
            CompanyId: $CompanyId
            Customer: $Customer
            CustomerCode: $CustomerCode
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            DueDateMin: $DueDateMin
            DueDateMax: $DueDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            InvoiceIds: $InvoiceIds
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
        }
    ) {
        Invoices {
            Id
            Number
            InvoiceCode
            Customer {
                Id
            }
            AmountOwing
            State
        }
    }
}

query GET_CREDITS_FOR_COMPANY(
    $CompanyId: ID
    $CreditNumber: String
    $Customer: String
    $CustomerCode: String
    $CustomerId: ID
    $CreatedDateMin: String
    $CreatedDateMax: String
    $AvailableDateMin: String
    $AvailableDateMax: String
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CreditState: String
    $CreditIds: [ID]
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $IsCloudImportType: Boolean = false
    $ExcludeCredits: Boolean
    $CustomerFirstLetter: [String]
    $Type: String
    $CreatedType: String
    $Recurring: Boolean
    $MultipleCustomer: Boolean
    $ViewAssociatedCustomers: Boolean = false
) {
    GetCreditsForCompany(
        Filter: {
            CompanyId: $CompanyId
            CreditNumber: $CreditNumber
            Customer: $Customer
            CustomerCode: $CustomerCode
            CreatedDateMin: $CreatedDateMin
            CustomerId: $CustomerId
            CreatedDateMax: $CreatedDateMax
            AvailableDateMin: $AvailableDateMin
            AvailableDateMax: $AvailableDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CreditState: $CreditState
            CreditIds: $CreditIds
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            ExcludeCredits: $ExcludeCredits
            CustomerFirstLetter: $CustomerFirstLetter
            Type: $Type
            CreatedType: $CreatedType
            Recurring: $Recurring
            MultipleCustomer: $MultipleCustomer
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        Credits {
            Id
            CreditCode
            Number
            CreatedDate
            LocalCreatedDate
            AvailableDate
            LocalAvailableDate
            OriginalAmount
            AmountAvailable
            State
            ClosedDate
            Customer {
                Id
                CustomerCode @skip(if: $IsCloudImportType)
                CompanyName
                DisplayName
                Contacts {
                    ...ContactFragment
                }
                CustomFields {
                    ...CustomFieldFragment
                }
            }
            Uri
            CustomFields {
                ...CustomFieldFragment
            }
            Attachments {
                ...AttachmentFragment
            }
            Type
            CreatedType
            Percentage
            Description
            IsRecurring
            MultipleCustomer
        }
    }
}

query GET_CREDITS_FOR_COMPANY_AUTOCOMPLETE_FILTER(
    $CreditNumber: String
    $Customer: String
    $CustomerCode: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $AvailableDateMin: String
    $AvailableDateMax: String
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CreditState: String
    $CreditIds: [ID]
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $CompanyId: ID
) {
    GetCreditsForCompany(
        Filter: {
            CreditNumber: $CreditNumber
            Customer: $Customer
            CustomerCode: $CustomerCode
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            AvailableDateMin: $AvailableDateMin
            AvailableDateMax: $AvailableDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CreditState: $CreditState
            CreditIds: $CreditIds
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            CompanyId: $CompanyId
        }
    ) {
        Credits {
            Number
        }
    }
}

query GET_INVOICE_DETAILS_FOR_COMPANY(
    $InvoiceId: ID
    $IsCalendarView: Boolean
    $IsCloudImportType: Boolean = false
    $IsInvoicePanelView: Boolean = false
) {
    GetInvoiceDetailsForCompany(
        InvoiceId: $InvoiceId
        IsCalendarView: $IsCalendarView
    ) {
        ...EnhancedInvoiceFragment
    }
}

query GET_INVOICE_DETAILS_FOR_ORGANISATION(
    $InvoiceId: ID
    $IsCalendarView: Boolean
    $IsCloudImportType: Boolean = false
    $CompanyId: ID
    $ConversionCurrency: Float
    $CompanyIds: [ID]
    $OrganisationCurrencies: [OrganisationCurrencyInput]
) {
    GetInvoiceDetailsForOrganisation(
        InvoiceId: $InvoiceId
        IsCalendarView: $IsCalendarView
        CompanyId: $CompanyId
        CompanyIds: $CompanyIds
        ConversionCurrency: $ConversionCurrency
        OrganisationCurrencies: $OrganisationCurrencies
    ) {
        ...InvoiceFragment
    }
}

query GET_CREDIT_DETAILS_FOR_COMPANY(
    $CreditId: ID
    $IsCalendarView: Boolean
    $IsCloudImportType: Boolean = false
) {
    GetCreditDetailsForCompany(
        CreditId: $CreditId
        IsCalendarView: $IsCalendarView
    ) {
        ...CreditFragment
    }
}

query GET_CREDIT_DETAILS_FOR_ORGANISATION(
    $CreditId: ID
    $IsCalendarView: Boolean
    $IsCloudImportType: Boolean = false
    $CompanyId: ID
    $ConversionCurrency: Float
    $CompanyIds: [ID]
    $OrganisationCurrencies: [OrganisationCurrencyInput]
) {
    GetCreditDetailsForOrganisation(
        CreditId: $CreditId
        IsCalendarView: $IsCalendarView
        CompanyId: $CompanyId
        CompanyIds: $CompanyIds
        ConversionCurrency: $ConversionCurrency
        OrganisationCurrencies: $OrganisationCurrencies
    ) {
        ...CreditFragment
    }
}

query GET_CREDITS_BY_CREDIT_CODES(
    $CreditCodes: [String]
    $IsCloudImportType: Boolean = false
) {
    GetCreditsByCreditCodes(CreditCodes: $CreditCodes) {
        Credits {
        ...CreditFragment
        }
    }
}

query GET_CUSTOMERS_FOR_COMPANY(
    $CompanyId: ID
    $Customer: String
    $CustomerIds: [ID]
    $CustomerId: ID
    $InclusiveContact: Boolean
    $Contact: Int
    $ATBType: Int
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $IsCloudImportType: Boolean = false
    $UsingCustomerWorkflow: Boolean = false
    $IsMultipleWorkflow: Boolean = false
    $IsVip: Boolean
    $CustomerCountry: String
    $CustomerState: String
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $CustomerFirstLetter: [String]
    $HasPaymentPlan: Boolean
    $ExcludeCustomers: Boolean
    $ViewAssociatedCustomers: Boolean = false
    $ExcludeParent: Boolean = false
    $VipUntilMax: String
    $VipUntilMin: String
    $StateOfCustomers: String
) {
    GetCustomersForCompany(
        Filter: {
            CompanyId: $CompanyId
            Customer: $Customer
            CustomerIds : $CustomerIds
            CustomerId: $CustomerId
            InclusiveContact: $InclusiveContact
            Contact: $Contact
            ATBType: $ATBType
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            IsVip: $IsVip
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            CustomerFirstLetter: $CustomerFirstLetter
            HasPaymentPlan: $HasPaymentPlan
            ExcludeCustomers: $ExcludeCustomers
            ViewAssociatedCustomers : $ViewAssociatedCustomers 
            ExcludeParent: $ExcludeParent
            VipUntilMax: $VipUntilMax
            VipUntilMin: $VipUntilMin
            StateOfCustomers: $StateOfCustomers
        }
    ) {
        Customers {
            ...CustomerFragment
            TicketCount
            ConversationLine {
                ...ConversationLineCommentFragment
            }
            LastCommunication @include(if: $UsingCustomerWorkflow) {
                StateName
                SentDateTime
                DeliveryDetails {
                    ...DeliveryDetailFragment
                }
                WorkflowName @include(if: $IsMultipleWorkflow)                
            }
            CurrentTask @include(if: $UsingCustomerWorkflow) {
                Id
                Automation
                ActionDate
                Type
                Workflow {
                    StateName
                    WorkflowName @include(if: $IsMultipleWorkflow)
                }
                Ticket {
                    TicketOption {
                        Reason
                        CaptureMessage
                    }
                    TicketNumber
                }
                State
            }
            AssignedUser {
                GivenName
                FamilyName
            }
            AssignedEmailAddress
            ParentCustomerCode
        }
    }
}

query GET_CUSTOMERS_FOR_COMPANY_AUTOCOMPLETE_FILTER(
    $Customer: String
    $InclusiveContact: Boolean
    $Contact: Int
    $ATBType: Int
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $CustomerCountry: String
    $CustomerState: String
    $CompanyId: ID
    $ViewAssociatedCustomers: Boolean = false
    $StateOfCustomers: String
) {
    GetCustomersForCompany(
        Filter: {
            Customer: $Customer
            InclusiveContact: $InclusiveContact
            Contact: $Contact
            ATBType: $ATBType
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CompanyId: $CompanyId
            ViewAssociatedCustomers: $ViewAssociatedCustomers
            StateOfCustomers: $StateOfCustomers
        }
    ) {
        Customers {
            Id
            DisplayName
            CompanyId
            CustomerCode
        }
    }
}

query GET_CUSTOMERS_FOR_ORGANISATION_AUTOCOMPLETE_FILTER(
    $Customer: String
    $InclusiveContact: Boolean
    $Contact: Int
    $ATBType: Int
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $IsCloudImportType: Boolean = false
    $Countries: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $OrganisationCurrencies: [OrganisationCurrencyInput]
    $ConversionCurrency: Float
    $IsVip: Boolean
    $CustomerCountry: String
    $CustomerState: String
    $UserId: ID
    $OrganisationId: ID 
    $FetchOrganisationData: Boolean = false
    $CustomerFirstLetter: [String]
    $StateOfCustomers: String
) {
    GetCustomersForOrganisation(
        FetchOrganisationData: $FetchOrganisationData
        Filter: {
            Customer: $Customer
            InclusiveContact: $InclusiveContact
            Contact: $Contact
            ATBType: $ATBType
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            OrganisationCurrencies: $OrganisationCurrencies
            ConversionCurrency: $ConversionCurrency
            IsVip: $IsVip
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            UserId: $UserId
            OrganisationId: $OrganisationId
            CustomerFirstLetter: $CustomerFirstLetter
            StateOfCustomers: $StateOfCustomers
        }
    ) {
        Customers {
            ...CustomerFragment
            ConversationLine {
                ...ConversationLineCommentFragment
            }
            Company {
                Name
            }
            ParentCustomerCode
        }
    }
}

query GET_CUSTOMER_DETAILS_FOR_COMPANY(
    $CustomerId: ID
    $IsCloudImportType: Boolean = false
) {
    GetCustomerDetailsForCompany(CustomerId: $CustomerId) {
        ...CustomerFragment
        ParentCustomer {
            ...CustomerFragment
        }
    }
}

query GET_CUSTOMER_DETAILS_FOR_ORGANISATION(
    $CompanyId: ID
    $CustomerId: ID
    $IsCloudImportType: Boolean = false
    $ConversionCurrency: Float
    $CompanyIds: [ID]
) {
    GetCustomerDetailsForOrganisation(
        CompanyId: $CompanyId
        CompanyIds: $CompanyIds
        CustomerId: $CustomerId
        ConversionCurrency: $ConversionCurrency
    ) {
        ...CustomerFragment
        Company {
            IsDueDateView
            IsCalendarView
        }
    }
}

query GET_CUSTOMER_SETTLEMENT_AVERAGE_DAYS_FOR_COMPANY(
    $CompanyId: ID
    $Customer: String
    $CustomerId: ID
    $CustomerCode: String
    $AmountOperator: String
    $NumberOfDays: Int
    $SettlementDateMin: AWSDateTime
    $SettlementDateMax: AWSDateTime
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomerCountry: String
    $CustomerState: String
    $ViewAssociatedCustomers: Boolean = false
) {
    GetCustomerSettlementAverageDaysForCompany(
        Filter: {
            CompanyId: $CompanyId
            Customer: $Customer
            CustomerId: $CustomerId
            CustomerCode: $CustomerCode
            AmountOperator: $AmountOperator
            NumberOfDays: $NumberOfDays
            SettlementDateMin: $SettlementDateMin
            SettlementDateMax: $SettlementDateMax
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        CustomerSettlementAverageDaysList {
            Customer {
                CustomerCode
                DisplayName
            }
            SettlementAverageDays
        }
    }
}

query GET_CUSTOMER_SETTLEMENT_AVERAGE_DAYS_FOR_ORGANISATION(
    $Customer: String
    $CustomerCode: String
    $AmountOperator: String
    $NumberOfDays: Int
    $SettlementDateMin: AWSDateTime
    $SettlementDateMax: AWSDateTime
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomerCountry: String
    $CustomerState: String
    $Countries: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $UserId: ID
    $OrganisationId: ID
    $CustomerId: ID
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetCustomerSettlementAverageDaysForOrganisation(
        Filter: {
            Customer: $Customer
            CustomerCode: $CustomerCode
            AmountOperator: $AmountOperator
            NumberOfDays: $NumberOfDays
            SettlementDateMin: $SettlementDateMin
            SettlementDateMax: $SettlementDateMax
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            UserId: $UserId
            OrganisationId: $OrganisationId
            CustomerId: $CustomerId
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        CustomerSettlementAverageDaysList {
            Customer {
                CustomerCode
                DisplayName
            }
            SettlementAverageDays
        }
    }
}

query GET_CATEGORIZED_NOTIFICATIONS_FOR_USER(
    $CompanyId: ID
) {
    GetCategorizedNotificationsForUser(
        CompanyId: $CompanyId
    ) {
        Notifications {
            Id
            CategoryId
            CategoryName
            Title
            Description
            CreatedDateTime
            ItemsCount
            Company {
                CompanyId
                Name
            }
            OrganisationId
            Region
            EntityType
            EntityKey
        }
    }
}

query GET_NOTIFICATIONS_BY_CATEGORY_FOR_USER(
    $CategoryId: ID
    $CompanyId: ID
) {
    GetNotificationsByCategoryForUser(
        CategoryId: $CategoryId
        CompanyId: $CompanyId
    ) {
        Notifications {
            Id
            Title
            CategoryName
            Description
            CreatedDateTime
            Company {
                CompanyId
                Name
            }
            OrganisationId
            Region
            IsRead
            EntityType
            EntityKey
        }
    }
}

query GET_TASKS_FOR_COMPANY(
    $DisplayName: String
    $CustomerCode: String
    $InvoiceNumber: String
    $InvoiceDueDateMin: AWSDateTime
    $InvoiceDueDateMax: AWSDateTime
    $AmountValue: Float
    $AmountOperator: String
    $ActionDateMin: AWSDateTime
    $ActionDateMax: AWSDateTime
    $CreatedDateMin: AWSDateTime
    $CreatedDateMax: AWSDateTime
    $Type: Int
    $Automation: Int
    $Contact: Int
    $Status: Int
    $TaskIds: [ID]
    $ExcludeTasks: Boolean
    $SortField: String
    $ThenSortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $IsCloudImportType: Boolean = false
    $IsMultipleWorkflow: Boolean = false
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $WorkflowFilters: [WorkflowFilterInput]
    $PaymentPlanEnabled: Boolean = false
    $CustomerCountry: String
    $CustomerState: String
    $Action: Int
    $CustomerFirstLetter: [String]
    $TicketOptionReasons: [String]
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
    $LastKeySet: Int
) {
    GetTasksForCompany(
        Filter: {
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            InvoiceNumber: $InvoiceNumber
            InvoiceDueDateMin: $InvoiceDueDateMin
            InvoiceDueDateMax: $InvoiceDueDateMax
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            ActionDateMin: $ActionDateMin
            ActionDateMax: $ActionDateMax
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            Type: $Type
            Automation: $Automation
            Contact: $Contact
            Status: $Status
            TaskIds: $TaskIds
            ExcludeTasks: $ExcludeTasks
            SortField: $SortField
            ThenSortField: $ThenSortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            WorkflowFilters: $WorkflowFilters
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            Action: $Action
            CustomerFirstLetter: $CustomerFirstLetter
            TicketOptionReasons:$TicketOptionReasons
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
            LastKeySet: $LastKeySet
        }
    ) {
        Tasks {
            Id
            ActionDate
            Automation
            ConversationLine {
                ...ConversationLineCommentFragment
            }
            Customer {
                Id
                Contacts {
                    ...ContactFragment
                }
                CustomerCode @skip(if: $IsCloudImportType)
                CompanyId
                CompanyName
                DisplayName
                CustomFields {
                    ...CustomFieldFragment
                }
                ConversationLine {
                    ...ConversationLineCommentFragment
                }
                PayerState
            }
            Invoice {
                Number
                AmountOwing
                CustomFields {
                    ...CustomFieldFragment
                }
                ConversationLine {
                    ...ConversationLineCommentFragment
                }
            }
            RemittanceAdvice {
                Id
                Amount
                AllocatedAmount
                Status
                ReceivedDate
                MultipleCustomer
                ConversationLine {
                    ...ConversationLineCommentFragment
                }
                IsLocked
            }
            Type
            Workflow {
                WorkflowId
                StateName
                DeliveryMethod
                WorkflowName @include(if: $IsMultipleWorkflow)
            }
            State
            Ticket {
                Id
                TicketNumber
                TicketOption {
                    Id
                    Type
                    Reason
                }
                ConversationLine {
                    ...ConversationLineCommentFragment
                }
                ConversationChatLine {
                    ...ConversationLineCommentFragment
                    Type
                    TypeClassification
                }
            }
            AssignedUser {
                UserId
                GivenName
                FamilyName
            }
            AssignedEmailAddress
            Payment {
                ...PaymentFragment
                Customer {
                    RemittanceAdviceCounts {
                        UnprocessedRAs
                        VerifiedRAs
                    }
                }
            }
            PaymentPlanSchedule @include(if: $PaymentPlanEnabled) {
                AmountRemaining
                Number
            }
            PaymentPlan @include(if: $PaymentPlanEnabled) {
                Id
                ConversationLine {
                    ...ConversationLineCommentFragment
                }
                Number,
                TotalAmount,
                FeeRemaining
            }
            ActionDateMovedBy
            CommonInvoiceCustomFields {
                ...CustomFieldFragment
            }
        }
        LastKeySet
    }
}

query GET_TASKS_FOR_ORGANISATION(
    $DisplayName: String
    $CustomerCode: String
    $InvoiceNumber: String
    $InvoiceDueDateMin: AWSDateTime
    $InvoiceDueDateMax: AWSDateTime
    $AmountValue: Float
    $AmountOperator: String
    $ActionDateMin: AWSDateTime
    $ActionDateMax: AWSDateTime
    $CreatedDateMin: AWSDateTime
    $CreatedDateMax: AWSDateTime
    $Type: Int
    $Automation: Int
    $Contact: Int
    $Status: Int
    $TaskIds: [ID]
    $ExcludeTasks: Boolean
    $SortField: String
    $ThenSortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $IsCloudImportType: Boolean = false
    $IsMultipleWorkflow: Boolean = false
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $WorkflowFilters: [WorkflowFilterInput]
    $PaymentPlanEnabled: Boolean = false
    $CustomerCountry: String
    $CustomerState: String
    $Action: Int
    $CompanyIds: [ID]
    $FetchOrganisationData: Boolean = false
    $CustomerFirstLetter: [String]
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTasksForOrganisation(
        FetchOrganisationData: $FetchOrganisationData
        Filter: {
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            InvoiceNumber: $InvoiceNumber
            InvoiceDueDateMin: $InvoiceDueDateMin
            InvoiceDueDateMax: $InvoiceDueDateMax
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            ActionDateMin: $ActionDateMin
            ActionDateMax: $ActionDateMax
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            Type: $Type
            Automation: $Automation
            Contact: $Contact
            Status: $Status
            TaskIds: $TaskIds
            ExcludeTasks: $ExcludeTasks
            SortField: $SortField
            ThenSortField: $ThenSortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            WorkflowFilters: $WorkflowFilters
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            Action: $Action
            CustomerFirstLetter: $CustomerFirstLetter
            CompanyIds: $CompanyIds
            CustomerFirstLetter: $CustomerFirstLetter
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        Tasks {
            Id
            CompanyId
            ActionDate
            Automation
            ConversationLine {
                ...ConversationLineCommentFragment
            }
            Customer {
                Id
                Contacts {
                    ...ContactFragment
                }
                CustomerCode @skip(if: $IsCloudImportType)
                CompanyId
                CompanyName
                DisplayName
                CustomFields {
                    ...CustomFieldFragment
                }
                ConversationLine {
                    ...ConversationLineCommentFragment
                }
                PayerState
            }
            Invoice {
                Number
                AmountOwing
                CustomFields {
                    ...CustomFieldFragment
                }
                ConversationLine {
                    ...ConversationLineCommentFragment
                }
            }
            Company {
                Name
            }
            RemittanceAdvice {
                Id
                Amount
                AllocatedAmount
                Status
                ReceivedDate
                MultipleCustomer
                ConversationLine {
                    ...ConversationLineCommentFragment
                }
                InvoicesAllocated
            }
            Type
            Workflow {
                WorkflowId
                StateName
                DeliveryMethod
                WorkflowName @include(if: $IsMultipleWorkflow)
            }
            State
            Ticket {
                Id
                TicketNumber
                TicketOption {
                    Id
                    Type
                    Reason
                }
                ConversationLine {
                    ...ConversationLineCommentFragment
                }
                ConversationChatLine {
                    ...ConversationLineCommentFragment
                    Type
                    TypeClassification
                }
            }
            AssignedUser {
                UserId
                GivenName
                FamilyName
            }
            AssignedEmailAddress
            Payment {
                ...PaymentFragment
            }
            PaymentPlanSchedule @include(if: $PaymentPlanEnabled) {
                AmountRemaining
                Number
            }
            PaymentPlan @include(if: $PaymentPlanEnabled) {
                Id
                ConversationLine {
                    ...ConversationLineCommentFragment
                }
                Number,
                TotalAmount
            }
            ActionDateMovedBy
            CommonInvoiceCustomFields {
                ...CustomFieldFragment
            }
        }
    }
}

query GET_TASKS_ACTION_FILTER_OPTIONS(
    $CompanyIds: [ID]
) {
    GetTasksActionFilterOptions(
        CompanyIds: $CompanyIds
    ) {
        InvoiceWorkflowOptions {
            Workflow {
                WorkflowId
                WorkflowName
            }
            States
        }
        TicketWorkflowOptions {
            Workflow {
                WorkflowId
                WorkflowName
            }
            States
        }
        CustomerWorkflowOptions {
            Workflow {
                WorkflowId
                WorkflowName
            }
            States
        }
        PaymentPlanWorkflowOptions {
            Workflow {
                WorkflowId
                WorkflowName
            }
            States
        }
        RemittanceAdviceWorkflowOptions {
            Workflow {
                WorkflowId
                WorkflowName
            }
            States
        }
        PaymentAllocationWorkflowOptions {
            Workflow {
                WorkflowId
                WorkflowName
            }
            States
        }
    }
}

query GET_TASK_DETAILS_FOR_COMPANY(
    $CompanyId: ID
    $TaskId: ID
    $LockedDeliveryMethod: Boolean = false
    $IsCloudImportType: Boolean = false
    $IsMultipleWorkflow: Boolean = false
    $PaymentPlanEnabled: Boolean = false
    $IsCalendarView: Boolean = false
) {
    GetTaskDetailsForCompany(
        CompanyId: $CompanyId
        TaskId: $TaskId, 
        IsCalendarView: $IsCalendarView
    ) {
        Id
        ActionDate
        Automation
        Customer {
            ...CustomerFragment
        }
        Invoice {
            AgedTrialBalanceFromCreate {
                ...AgedTrialBalanceFromCreateFragment
            }
            AgedTrialBalanceFromDue {
                ...AgedTrialBalanceFromDueFragment
            }
            CreatedDate
            LocalCreatedDate
            DueDate
            LocalDueDate
            Number
            OriginalAmount
            AmountOwing
            CustomFields {
                ...CustomFieldFragment
            }
            Attachments {
                ...AttachmentFragment
            }
            Uri
            GlCode
        }
        Type
        Workflow {
            StateName
            DeliveryMethod @include(if: $LockedDeliveryMethod)
            WorkflowName @include(if: $IsMultipleWorkflow)
        }
        State
        CreatedDateTime
        Ticket {
            Id
            TicketNumber
            State
            Details
            ResolvedReason
            ResolvedDateTime
            CreatedDateTime
            TicketOption {
                ...TicketOptionFragment
            }
            Invoices {
                Id
            }
            ClosedBy {
                GivenName
                FamilyName
            }
            ExternalEmailAddress
            Attachments {
                ...AttachmentFragment
            }
            Uri
        }
        RemittanceAdvice {
            Id
            Amount
            Status
            ReceivedDate
            LocalReceivedDate
            PaidDate
            LocalPaidDate
            MultipleCustomer
        }
        AssignedUser {
            GivenName
            FamilyName
        }
        AssignedEmailAddress
        Payment {
            ...PaymentFragment
        }
        PaymentPlanSchedule @include(if: $PaymentPlanEnabled) {
            Number
            AmountRemaining
            LocalDueDateTime
            State
        }
        PaymentPlan @include(if: $PaymentPlanEnabled) {
            Id
            State
            InvoiceIds
            TotalAmount
            AmountRemaining
            LocalRequestedDateTime
            LocalApprovedDateTime
            Number
            LocalClosedDateTime
            TotalSchedules
            Frequency
            PaymentPlanSchedules {
                Id
                PaymentPlanId
                Number
                State
                TotalAmount
                AmountRemaining
                LocalDueDateTime
                DueDateTime
                LocalClosedDateTime
            }
            ClosedComment
        }
        ConversationLine {
            ...ConversationLineCommentFragment
        }
        IsCalendarView
    }
}

query GET_TASK_CUSTOMER_CUSTOM_FIELDS_FOR_COMPANY(
    $CompanyId: ID
    $FieldNames: [String]
) {
    GetTaskCustomerCustomFieldsForCompany(
        CompanyId: $CompanyId
        FieldNames: $FieldNames
    ){
        CustomFieldValues {
            Name
            Value
        }
    }
}

query GET_TASK_INVOICE_CUSTOM_FIELDS_FOR_COMPANY(
    $CompanyId: ID
    $FieldNames: [String]
) {
    GetTaskInvoiceCustomFieldsForCompany(
        CompanyId: $CompanyId
        FieldNames: $FieldNames
    ){
        CustomFieldValues {
            Name
            Value
        }
    }
}

query GET_CUSTOMER_CUSTOM_FIELDS_FOR_COMPANY(
    $CompanyId: ID
    $FieldNames: [String]
) {
    GetCustomerCustomFieldsForCompany(
        CompanyId: $CompanyId
        FieldNames: $FieldNames
    ){
        CustomFieldValues {
            Name
            Value
        }
    }
}

query GET_INVOICE_CUSTOM_FIELDS_FOR_COMPANY(
    $CompanyId: ID
    $FieldNames: [String]
) {
    GetInvoiceCustomFieldsForCompany(
        CompanyId: $CompanyId
        FieldNames: $FieldNames
    ){
        CustomFieldValues {
            Name
            Value
        }
    }
}

query GET_CREDIT_CUSTOM_FIELDS_FOR_COMPANY(
    $CompanyId: ID
    $FieldNames: [String]
) {
    GetCreditCustomFieldsForCompany(
        CompanyId: $CompanyId
        FieldNames: $FieldNames
    ){
        CustomFieldValues {
            Name
            Value
        }
    }
}

query GET_TICKET_CUSTOM_FIELDS_FOR_COMPANY(
    $CompanyId: ID
    $FieldNames: [String]
) {
    GetTicketCustomFieldsForCompany(
        CompanyId: $CompanyId
        FieldNames: $FieldNames
    ){
        CustomFieldValues {
            Name
            Value
        }
    }
}

query GET_PAYMENTS_CUSTOM_FIELDS_FOR_COMPANY(
    $CompanyId: ID
    $FieldNames: [String]
) {
    GetPaymentsCustomFieldsForCompany(
        CompanyId: $CompanyId
        FieldNames: $FieldNames
    ){
        CustomFieldValues {
            Name
            Value
        }
    }
}

query GET_RA_CUSTOM_FIELDS_FOR_COMPANY(
    $CompanyId: ID
    $FieldNames: [String]
) {
    GetRACustomFieldsForCompany(
        CompanyId: $CompanyId
        FieldNames: $FieldNames
    ){
        CustomFieldValues {
            Name
            Value
        }
    }
}

query GET_TASK_CUSTOMER_CUSTOM_FIELDS_FOR_ORGANISATION(
    $CompanyIds: [ID]
    $FieldNames: [String]
) {
    GetTaskCustomerCustomFieldsForOrganisation(
        CompanyIds: $CompanyIds
        FieldNames: $FieldNames
    ){
        CustomFieldValues {
            Name
            Value
        }
    }
}

query GET_TASK_INVOICE_CUSTOM_FIELDS_FOR_ORGANISATION(
    $CompanyIds: [ID]
    $FieldNames: [String]
) {
    GetTaskInvoiceCustomFieldsForOrganisation(
        CompanyIds: $CompanyIds
        FieldNames: $FieldNames
    ){
        CustomFieldValues {
            Name
            Value
        }
    }
}

query GET_CUSTOMER_CUSTOM_FIELDS_FOR_ORGANISATION(
    $CompanyIds: [ID]
    $FieldNames: [String]
) {
    GetCustomerCustomFieldsForOrganisation(
        CompanyIds: $CompanyIds
        FieldNames: $FieldNames
    ){
        CustomFieldValues {
            Name
            Value
        }
    }
}

query GET_INVOICE_CUSTOM_FIELDS_FOR_ORGANISATION(
    $CompanyIds: [ID]
    $FieldNames: [String]
) {
    GetInvoiceCustomFieldsForOrganisation(
        CompanyIds: $CompanyIds
        FieldNames: $FieldNames
    ){
        CustomFieldValues {
            Name
            Value
        }
    }
}

query GET_CREDIT_CUSTOM_FIELDS_FOR_ORGANISATION(
    $CompanyIds: [ID]
    $FieldNames: [String]
) {
    GetCreditCustomFieldsForOrganisation(
        CompanyIds: $CompanyIds
        FieldNames: $FieldNames
    ){
        CustomFieldValues {
            Name
            Value
        }
    }
}

query GET_TICKET_CUSTOM_FIELDS_FOR_ORGANISATION(
    $CompanyIds: [ID]
    $FieldNames: [String]
) {
    GetTicketCustomFieldsForOrganisation(
        CompanyIds: $CompanyIds
        FieldNames: $FieldNames
    ){
        CustomFieldValues {
            Name
            Value
        }
    }
}

query GET_PAYMENTS_CUSTOM_FIELDS_FOR_ORGANISATION(
    $CompanyIds: [ID]
    $FieldNames: [String]
) {
    GetPaymentsCustomFieldsForOrganisation(
        CompanyIds: $CompanyIds
        FieldNames: $FieldNames
    ){
        CustomFieldValues {
            Name
            Value
        }
    }
}

query GET_RA_CUSTOM_FIELDS_FOR_ORGANISATION(
    $CompanyIds: [ID]
    $FieldNames: [String]
) {
    GetRACustomFieldsForOrganisation(
        CompanyIds: $CompanyIds
        FieldNames: $FieldNames
    ){
        CustomFieldValues {
            Name
            Value
        }
    }
}

query GET_CUSTOMER_FIRST_LETTER_VALUES(
    $CompanyId: ID
) {
    GetCustomerFirstLetterValues(CompanyId: $CompanyId){
        Values
    }
}

query GET_TASK_DETAILS_FOR_ORGANISATION(
    $TaskId: ID
    $CompanyId: ID
    $LockedDeliveryMethod: Boolean = false
    $IsCloudImportType: Boolean = false
    $IsMultipleWorkflow: Boolean = false
    $PaymentPlanEnabled: Boolean = false
) {
    GetTaskDetailsForOrganisation(
        TaskId: $TaskId
        CompanyId: $CompanyId
    ) {
        Id
        ActionDate
        Automation
        Customer {
            ...CustomerFragment
        }
        Invoice {
            AgedTrialBalanceFromCreate {
                ...AgedTrialBalanceFromCreateFragment
            }
            AgedTrialBalanceFromDue {
                ...AgedTrialBalanceFromDueFragment
            }
            CreatedDate
            LocalCreatedDate
            DueDate
            LocalDueDate
            Number
            OriginalAmount
            AmountOwing
            CustomFields {
                ...CustomFieldFragment
            }
            Attachments {
                ...AttachmentFragment
            }
            Uri
            GlCode
        }
        Type
        Workflow {
            StateName
            DeliveryMethod @include(if: $LockedDeliveryMethod)
            WorkflowName @include(if: $IsMultipleWorkflow)
        }
        State
        CreatedDateTime
        Ticket {
            Id
            TicketNumber
            State
            Details
            ResolvedReason
            ResolvedDateTime
            CreatedDateTime
            TicketOption {
                ...TicketOptionFragment
            }
            Invoices {
                Id
            }
            ClosedBy {
                GivenName
                FamilyName
            }
            ExternalEmailAddress
            Attachments {
                ...AttachmentFragment
            }
            Uri
        }
        RemittanceAdvice {
            Id
            Amount
            Status
            ReceivedDate
            LocalReceivedDate
            PaidDate
            LocalPaidDate
            MultipleCustomer
        }
        AssignedUser {
            GivenName
            FamilyName
        }
        AssignedEmailAddress
        Payment {
            ...PaymentFragment
        }
        PaymentPlanSchedule @include(if: $PaymentPlanEnabled) {
            Number
            AmountRemaining
            LocalDueDateTime
            State
        }
        PaymentPlan @include(if: $PaymentPlanEnabled) {
            Id
            State
            InvoiceIds
            TotalAmount
            AmountRemaining
            LocalRequestedDateTime
            LocalApprovedDateTime
            Number
            LocalClosedDateTime
            TotalSchedules
            Frequency
            PaymentPlanSchedules {
                Id
                PaymentPlanId
                Number
                State
                TotalAmount
                AmountRemaining
                LocalDueDateTime
                DueDateTime
                LocalClosedDateTime
            }
            ClosedComment
        }
        ConversationLine {
            ...ConversationLineCommentFragment
        }
    }
}

query GET_CUSTOMER_FIRST_LETTER_VALUES_FOR_ORGANISATION(
    $CompanyIds: [ID]
) {
    GetCustomerFirstLetterValuesForOrganisation(CompanyIds: $CompanyIds) {
        Values
    }
}

query CHECK_TASKS_ACTION_STATE(
    $DisplayName: String
    $CustomerCode: String
    $CustomerCountry: String
    $CustomerState: String
    $InvoiceNumber: String
    $InvoiceDueDateMin: AWSDateTime
    $InvoiceDueDateMax: AWSDateTime
    $ActionDateMin: AWSDateTime
    $ActionDateMax: AWSDateTime
    $CreatedDateMin: AWSDateTime
    $CreatedDateMax: AWSDateTime
    $AmountValue: Float
    $AmountOperator: String
    $Type: Int
    $Automation: Int
    $Contact: Int
    $Status: Int
    $TaskIds: [ID]
    $ExcludeTasks: Boolean
    $SortField: String
    $ThenSortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $WorkflowFilters: [WorkflowFilterInput]
    $RecordLimit: Int
    $SortField: String
    $ThenSortField: String
    $Ascending: Boolean
    $Type: Int
    $TicketOptionReasons: [String]
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    TasksActionState(
        Filter: {
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            InvoiceNumber: $InvoiceNumber
            InvoiceDueDateMin: $InvoiceDueDateMin
            InvoiceDueDateMax: $InvoiceDueDateMax
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            ActionDateMin: $ActionDateMin
            ActionDateMax: $ActionDateMax
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            Type: $Type
            Automation: $Automation
            Contact: $Contact
            Status: $Status
            TaskIds: $TaskIds
            ExcludeTasks: $ExcludeTasks
            SortField: $SortField
            ThenSortField: $ThenSortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            WorkflowFilters: $WorkflowFilters
            RecordLimit: $RecordLimit
            SortField: $SortField
            ThenSortField: $ThenSortField
            Ascending: $Ascending
            Type: $Type
            TicketOptionReasons: $TicketOptionReasons
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        ActionEnabled
        ActionType
        ActionAutomation
        TotalTaskCount
    }
}

query CHECK_TASKS_READY_STATE_FOR_ORGANISATION(
    $DisplayName: String
    $CustomerCode: String
    $CustomerCountry: String
    $CustomerState: String
    $InvoiceNumber: String
    $InvoiceDueDateMin: AWSDateTime
    $InvoiceDueDateMax: AWSDateTime
    $ActionDateMin: AWSDateTime
    $ActionDateMax: AWSDateTime
    $CreatedDateMin: AWSDateTime
    $CreatedDateMax: AWSDateTime
    $AmountValue: Float
    $AmountOperator: String
    $Type: Int
    $Automation: Int
    $Contact: Int
    $Status: Int
    $TaskIds: [ID]
    $ExcludeTasks: Boolean
    $SortField: String
    $ThenSortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $WorkflowFilters: [WorkflowFilterInput]
    $RecordLimit: Int
    $SortField: String
    $ThenSortField: String
    $Ascending: Boolean
    $Type: Int
    $CompanyIds: [ID]
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    TasksActionStateForOrganisation(
        Filter: {
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            InvoiceNumber: $InvoiceNumber
            InvoiceDueDateMin: $InvoiceDueDateMin
            InvoiceDueDateMax: $InvoiceDueDateMax
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            ActionDateMin: $ActionDateMin
            ActionDateMax: $ActionDateMax
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            Type: $Type
            Automation: $Automation
            Contact: $Contact
            Status: $Status
            TaskIds: $TaskIds
            ExcludeTasks: $ExcludeTasks
            SortField: $SortField
            ThenSortField: $ThenSortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            WorkflowFilters: $WorkflowFilters
            RecordLimit: $RecordLimit
            SortField: $SortField
            ThenSortField: $ThenSortField
            Ascending: $Ascending
            Type: $Type
            CompanyIds: $CompanyIds
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        ActionEnabled
        ActionType
        ActionAutomation
        TotalTaskCount
    }
}

query GET_TASK_BATCH_HISTORY_FOR_COMPANY(
    $DisplayName: String
    $CustomerCode: String
    $InvoiceNumber: String
    $Type: Int
    $Status: Int
    $ActionDateMin: String
    $ActionDateMax: String
    $ActionedByUserId: ID
    $ActionedByEmailAddress: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTaskBatchHistoryForCompany(
        Filter: {
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            InvoiceNumber: $InvoiceNumber
            Type: $Type
            Status: $Status
            ActionDateMin: $ActionDateMin
            ActionDateMax: $ActionDateMax
            ActionedByUserId: $ActionedByUserId
            ActionedByEmailAddress: $ActionedByEmailAddress
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TaskBatches {
            BatchId
            CompanyId
            UserId
            Type
            State
            Automation
            CreatedDateTime
            BatchCount
            Action
            User {
                GivenName
                FamilyName
            }
            AssignedEmailAddress
        }
    }
}

query GET_TASK_BATCH_HISTORY_FOR_ORGANISATION(
    $CompanyIds: [ID]
    $DisplayName: String
    $CustomerCode: String
    $InvoiceNumber: String
    $Type: Int
    $Status: Int
    $ActionDateMin: String
    $ActionDateMax: String
    $ActionedByUserId: ID
    $ActionedByEmailAddress: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTaskBatchHistoryForOrganisation(
        Filter: {
            CompanyIds: $CompanyIds
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            InvoiceNumber: $InvoiceNumber
            Type: $Type
            Status: $Status
            ActionDateMin: $ActionDateMin
            ActionDateMax: $ActionDateMax
            ActionedByUserId: $ActionedByUserId
            ActionedByEmailAddress: $ActionedByEmailAddress
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TaskBatches {
            BatchId
            CompanyId
            UserId
            Type
            State
            Automation
            CreatedDateTime
            BatchCount
            Action
            User {
                GivenName
                FamilyName
            }
            AssignedEmailAddress
        }
    }
}

query GET_NEW_NOTIFICATIONS_FOR_USER($CreatedDateTime: String) {
    GetNewNotificationsForUser(CreatedDateTime: $CreatedDateTime) {
        Notifications {
            Id
            Description
            Title
            CategoryId
            CategoryName
            CreatedDateTime
            Company {
                CompanyId
                Name
                LogoPath
            }
            OrganisationId
            Region
            EntityType
            EntityKey
        }
    }
}

# FOR IMPORT
query GET_IMPORT_JOB_STATES_FOR_COMPANY(
    $Skip: Int
    $PageSize: Int
)
 {
    GetImportJobStatesForCompany(
        Filter: { 
            Skip: $Skip
            PageSize: $PageSize 
        }
    ) {
        ImportJobStates {
            Id
            User {
                GivenName
                FamilyName
            }
            Status
            StartDateTime
            EndDateTime
            TotalWarnings
        }
    }
}

query GET_MESSAGES_FOR_IMPORT_JOB(
    $ImportJobId: ID!
    $Skip: Int
    $PageSize: Int
) {
    GetMessagesForImportJob(
        Filter: { 
            ImportJobId: $ImportJobId
            Skip: $Skip
            PageSize: $PageSize
        }
    ) {
        ImportStagingMessages {
            RowNumber
            InvoiceCode
            CustomerCode
            Message
            Type
        }
    }
}

# FOR PAYMENT PLAN IMPORT
query GET_PAYMENT_PLAN_IMPORT_JOB_STATES {
    GetPaymentPlanImportJobStates {
        ImportJobStates {
            Id
            User {
                GivenName
                FamilyName
            }
            Status
            StartDateTime
            EndDateTime
            TotalWarnings
            TotalPaymentPlanCreated
        }
    }
}

# FOR MANUAL COMMUNICATIONS IMPORT
query GET_MANUAL_COMMUNICATIONS_IMPORT_JOB_STATES {
    GetManualCommunicationImportJobStates {
        ImportJobStates {
            Id
            User {
                GivenName
                FamilyName
            }
            Status
            StartDateTime
            EndDateTime
            TotalWarnings
            TotalManualCommunicationSent
        }
    }
}

# FOR BANKFILE IMPORT
query GET_BANK_FILE_PAYMENT_JOB_STATES {
    GetBankFilePaymentJobStates {
        ImportJobStates {
            Id
            User {
                GivenName
                FamilyName
            }
            Status
            StartDateTime
            EndDateTime
            TotalWarnings
        }
    }
}

query GET_BANK_FILE_PAYMENT_MESSAGE(
    $ImportJobId: ID!
    $Skip: Int
    $PageSize: Int
) {
    GetBankFilePaymentMessages(
        Filter: { 
            ImportJobId: $ImportJobId
            Skip: $Skip
            PageSize: $PageSize
        }
    ) {
        ImportStagingMessages {
            RowNumber
            InvoiceCode
            CustomerCode
            Message
            Type
        }
    }
}

query GET_PAYMENT_PLAN_MESSAGES_FOR_IMPORT_JOB(
    $ImportJobId: ID!
    $Skip: Int
    $PageSize: Int
) {
    GetPaymentPlanMessagesForImportJob(
        Filter: { 
            ImportJobId: $ImportJobId
            Skip: $Skip
            PageSize: $PageSize
        }
    ) {
        ImportStagingMessages {
            RowNumber
            InvoiceCode
            PaymentPlanCode
            Message
            Type
        }
    }
}

query GET_MANUAL_COMMUNICATIONS_MESSAGES_FOR_IMPORT_JOB(
    $ImportJobId: ID!
    $Skip: Int
    $PageSize: Int
) {
    GetManualCommunicationMessagesForImport(
        Filter: { 
            ImportJobId: $ImportJobId
            Skip: $Skip
            PageSize: $PageSize
        }
    ) {
        ImportStagingMessages {
            RowNumber
            InvoiceCode
            Communication
            Message
            Type
        }
    }
}

query GET_UNREAD_NOTIFICATION_CATEGORIES_FOR_USER {
    GetUnreadNotificationCategoriesForUser
}

#query GET_UNREAD_NOTIFICATION_CATEGORIES_FOR_USER(
#    $CompanyId: ID
#) {
#    GetUnreadNotificationCategoriesForUser(
#        CompanyId: $CompanyId
#    )
#}

query GET_FILE_LOCATION($FileId: ID!) {
    GetFileLocation(FileId: $FileId)
}

query GET_TASK_BATCH_GROUP_HISTORY_FOR_COMPANY(
    $CompanyId: ID
    $BatchId: ID
    $DisplayName: String
    $CustomerCode: String
    $InvoiceNumber: String
    $Status: Int
    $SortField: String
    $ThenSortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $IsCloudImportType: Boolean = false
    $WorkflowFilters: [WorkflowFilterInput]
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
    $TaskBatchGroupType: Int
) {
    GetTaskBatchGroupHistoryForCompany(
        Filter: {
            CompanyId: $CompanyId
            BatchId: $BatchId
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            WorkflowFilters: $WorkflowFilters
            InvoiceNumber: $InvoiceNumber
            Status: $Status
            SortField: $SortField
            ThenSortField: $ThenSortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
            TaskBatchGroupType: $TaskBatchGroupType
        }
    ) {
        TaskBatchGroups {
            GroupId
            WorkflowId
            BatchId
            StateName
            State
            CustomerCode @skip(if: $IsCloudImportType)
            Customer {
                ...CustomerFragment
            }
            CommunicationId
            Contact
            Comment
        }
    }
}

query GET_TASK_BATCH_GROUP_DELIVERY_HISTORY_FOR_COMPANY(
    $CompanyId: ID
	$BatchId: ID
	$DisplayName: String
	$CustomerCode: String
	$WorkflowFilters: [WorkflowFilterInput]
	$InvoiceNumber: String
	$Status: Int
	$DeliveryStatus: Int
	$DeliveryType: Int
	$SortField: String
	$ThenSortField: String
	$Ascending: Boolean
	$Skip: Int
	$PageSize: Int
    $IsCloudImportType: Boolean = false
) {
    GetTaskBatchGroupDeliveryHistoryForCompany(
        Filter: {
            CompanyId: $CompanyId
            BatchId: $BatchId
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            WorkflowFilters: $WorkflowFilters
            InvoiceNumber: $InvoiceNumber
            Status: $Status
            SortField: $SortField
            ThenSortField: $ThenSortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            DeliveryStatus: $DeliveryStatus
		    DeliveryType: $DeliveryType
        }
    ) {
        TaskBatchGroups {
            GroupId
            WorkflowId
            BatchId
            StateName
            State
            CustomerCode @skip(if: $IsCloudImportType)
            Customer {
                CustomerCode @skip(if: $IsCloudImportType)
                DisplayName
                CompanyName
                Contacts {
                    ...ContactFragment
                }
            }
            CommunicationId
            Contact
            DeliveryDetails {
                ...DeliveryDetailsFragment
            }
        }
    }
}

query GET_TASK_HISTORY_FOR_COMPANY(
    $CompanyId: ID
    $BatchId: ID!
    $GroupId: Int
    $Skip: Int
    $PageSize: Int
    $Ascending: Boolean
) {
    GetTaskHistoryForCompany(
        Filter: {
            CompanyId: $CompanyId
            BatchId: $BatchId
            GroupId: $GroupId
            Skip: $Skip
            PageSize: $PageSize
            Ascending: $Ascending
        }
    ) {
        TaskHistories {
            Id
            UserId
            State
            Invoice {
                Number
            }
            Customer {
                Id
                Contacts {
                    ...ContactFragment
                }
                CustomerCode 
                DisplayName
            }
            ActionDate
            ClosedDateTime
            Type
            Automation
            Ticket {
                TicketNumber
            }
            PaymentPlanSchedule {
                Number
            }
            PaymentPlan {
                Number
            }
        }
    }
}

query GET_NOTIFICATION_COMMUNICATION_DETAIL(
    $CommunicationId: ID!
    $AllInvoices: Boolean
    $IsPublic: Boolean = true
    $PaymentPlanEnabled: Boolean = false
    $InvoicesAndCreditsOnly: Boolean = false
) {
    GetNotificationCommunicationDetail(
        Filter: { 
            CommunicationId: $CommunicationId
            AllInvoices: $AllInvoices
        }
    ) {
        Contents @skip(if: $InvoicesAndCreditsOnly) {
            TemplateS3Key
            File {
                Id
                FileLocation
            }
        }
        Customer @skip(if: $InvoicesAndCreditsOnly) {
            Id
            CustomerCode
            DisplayName
            Contacts {
                Email
            }
            CustomFields {
                ...CustomFieldFragment
            }
        }
        Invoices @include(if: $InvoicesAndCreditsOnly) {
            Id
            CompanyId
            Customer {
                Id
                CustomerCode
                DisplayName
                # CompanyName
            }
            InvoiceCode
            Number
            CreatedDate
            LocalCreatedDate
            DueDate
            LocalDueDate
            AmountOwing
            GlCode
            Tickets {
                Id
                TicketNumber
                TicketOption {
                    Id
                    Type
                    Reason
                    NonBlocking
                }
            }
            CustomFields {
                Name
                Value
            }
            Attachments {
                ...AttachmentFragment
            }
            ResourceAllocations {
                PaymentResource {
                    Result
                    LocalPaidDate
                    BankReceiptNumber
                }
            }
            PaymentPlan @include(if: $PaymentPlanEnabled) {
                Id
                State
            }
            PaymentInstalmentFrequency @include(if: $PaymentPlanEnabled)
        }
        Company @skip(if: $InvoicesAndCreditsOnly) {
            CompanyId
            Name
            Email
            LogoPath
            AddressLine1
            AddressLine2
            Suburb
            State
            Postcode
            PhoneNumber
            PaymentOptions {
                ...PaymentOptionsFragment
            }
            PrimaryColorTheme
            CustomFieldsConfigure {
                ...CompanyCustomFieldConfigureFragment
            }
            LanguagePackage {
                ...LanguagePackageFragment
            }
            Timezone
            CompanyPaymentPlan {
                IsEnabled
                TermsAndConditions
                TotalSchedules
                Frequency
            }
            NotificationCustomization {
                ...CompanyNotificationCustomizationFragment
            }
            DisableRequestPaymentPlan
            EnableMultiplePaymentPlanOptions
            DisableCustomerTickets
            CustomerTitleLabel
        }
        AvailableCredits @include(if: $InvoicesAndCreditsOnly) {
            Id
            Number
            AvailableDate
            LocalAvailableDate
            AmountAvailable
            Customer {
                Id
                CustomerCode
                DisplayName
                # CompanyName
            }
            CustomFields {
                ...CustomFieldFragment
            }
            Attachments {
                ...AttachmentFragment
            }
        }
    }
}

query GET_COMMUNICATION_DETAIL(
    $CommunicationId: ID!
    $AllInvoices: Boolean 
    # $IsPublic: Boolean = false
) {
    GetCommunicationDetail(
        Filter: { 
            CommunicationId: $CommunicationId
            AllInvoices: $AllInvoices
        }
    ) {
        Contents {
            TemplateS3Key
            File {
                Id
                FileLocation
            }
            Type
        }
        Customer {
            Id
        }
        Invoices {
            Id
        }
        ContactMethod
        SentDateTime
        WorkflowStateName
    }
}

query GET_CORPAY_CURRENCIES_FOR_COMPANY($CompanyId: ID) {
    GetCorpayCurrenciesForCompany(CompanyId: $CompanyId)
}

query GET_TASK_HISTORY_QUEUED_TASKS_COUNT(
    $BatchId: ID
    $CompanyId: ID
) {
    GetTaskHistoryQueuedTasksCount(
        BatchId: $BatchId
        CompanyId: $CompanyId
    )
}

query GET_TASK_BATCH_STATUS(
    $BatchId: ID
    $CompanyId: ID
) {
    GetTaskBatchStatus(
        BatchId: $BatchId
        CompanyId: $CompanyId
    ) {
        State
        CompletedDateTime
        SentNotificationsCount
    }
}

query DOWNLOAD_MERGED_PDF($BatchId: ID) {
    DownloadMergePdf(BatchId: $BatchId)
}

query ENABLE_DOWNLOAD_MERGE_PDF_LINK(
    $BatchId: ID
    $CompanyId: ID
) {
    EnableDownloadMergePdfLink(
        BatchId: $BatchId
        CompanyId: $CompanyId
    )
}

query GET_BATCH_EDIT_DETAILS(
    $BatchId: ID
    $CompanyId: ID
) {
    GetBatchEditDetails(
        BatchId: $BatchId
        CompanyId: $CompanyId
    ) {
        Comment
        ActionDateTime
        User {
            GivenName
            FamilyName
        }
        WorkflowStateName
        AssignedUser {
            GivenName
            FamilyName
        }
        AssignedEmailAddress
    }
}

query GET_TASK_BATCH_HISTORY_DETAILS(
    $BatchId: ID
    $CompanyId: ID
) {
    GetTaskBatchHistoryDetails(
        BatchId: $BatchId
        CompanyId: $CompanyId
    ) {
        CompanyId
        Action
        CreatedDateTime
        User {
            GivenName
            FamilyName
        }
        AssignedEmailAddress
    }
}

query GET_BATCH_COLLECTION_DETAILS(
    $BatchId: ID
    $CompanyId: ID
) {
    GetBatchCollectionDetails(
        BatchId: $BatchId
        CompanyId: $CompanyId
    ) {
        ActionDateTime
        User {
            GivenName
            FamilyName
        }
        SentTo
    }
}

query GET_EDIT_TASKS_FAILED_FOR_COMPANY(
    $CompanyId: ID
    $BatchId: ID
    $Skip: Int
    $PageSize: Int
) {
    GetEditTasksFailedForCompany(
        Filter: { 
            CompanyId: $CompanyId
            BatchId: $BatchId
            Skip: $Skip
            PageSize: $PageSize
        }
    ) {
        Tasks {
            Id
            ActionDate
            Automation
            Customer {
                Contacts {
                    ...ContactFragment
                }
                CustomerCode
                DisplayName
            }
            Invoice {
                Number
                AmountOwing
            }
            Type
            Workflow {
                StateName
            }
            State
            PaymentPlanSchedule {
                Number
            }
            Ticket {
                TicketNumber
            }
        }
    }
}

query GET_TICKET_OPTIONS_FOR_COMPANY($CompanyId: ID!) {
    GetTicketOptionsForCompany(CompanyId: $CompanyId) {
        TicketOptions {
            ...TicketOptionFragment
            WorkflowId
        }
    }
}

query GET_TICKETS_FOR_COMPANY(
    $DisplayName: String
    $CustomerCode: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $ClosedDateMin: String
    $ClosedDateMax: String
    $Status: Int
    $Action: Int
    $TicketOptionReasons: [String]
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $IsCloudImportType: Boolean = false
    $CustomerCountry: String
    $CustomerState: String
    $LastChatDateMin: String
    $LastChatDateMax: String
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $TicketNumber: String
    $CustomerFirstLetter: [String]
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTicketsForCompany(
        Filter: {
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            ClosedDateMin: $ClosedDateMin
            ClosedDateMax: $ClosedDateMax
            Status: $Status
            Action: $Action
            TicketOptionReasons: $TicketOptionReasons
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            LastChatDateMin: $LastChatDateMin
            LastChatDateMax: $LastChatDateMax
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            TicketNumber: $TicketNumber
            CustomerFirstLetter: $CustomerFirstLetter
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        Tickets {
            Id
            TicketNumber
            State
            Details
            ResolvedReason
            ResolvedDateTime
            CreatedDateTime
            TicketOption {
                ...TicketOptionFragment
            }
            Customer {
                ...CustomerFragment
            }
            Attachments {
                ...AttachmentFragment
            }
            ConversationLine {
                ...ConversationLineCommentFragment
            }
            ConversationChatLine {
                ...ConversationLineCommentFragment
                Type
                TypeClassification
            }
            AssignedUser {
                GivenName
                FamilyName
            }
            AssignedEmailAddress
        }
    }
}

query GET_TICKET_DETAILS_FOR_COMPANY(
    $TicketId: ID
    $IsCloudImportType: Boolean = false
) {
    GetTicketDetailsForCompany(TicketId: $TicketId) {
        Id
        TicketNumber
        State
        Details
        ResolvedReason
        ResolvedDateTime
        CreatedDateTime
        TicketOption {
            ...TicketOptionFragment
        }
        Customer {
            ...CustomerFragment
        }
        Invoices {
            Id
        }
        Uri
        ClosedBy {
            GivenName
            FamilyName
        }
        ExternalEmailAddress
        Attachments {
            ...AttachmentFragment
        }
    }
}

query GET_TICKET_INFO_FOR_CHAT_VALIDATION(
    $CompanyId: ID
    $TicketId: ID
) {
    GetTicketInfoForChatValidation(
        CompanyId: $CompanyId
        TicketId: $TicketId
    ) {
        Id
        State
        Invoices {
            Id
            State
        }
        Uri
    }
}

query GET_TASKS_FOR_RESOURCE($Uri: String) {
    GetTasksForResource(Uri: $Uri) {
        Tasks {
            Id
            Type
            Automation
            ActionDate
            State
            Workflow {
                WorkflowId
                StateName
            }
            CreatedDateTime
            ClosedDateTime
            AssignedUser {
                GivenName
                FamilyName
            }
            AssignedEmailAddress
            TaskBatch {
                User {
                    GivenName
                    FamilyName
                }
                AssignedEmailAddress
            }
            TaskBatchGroup {
                Comment
                CapturedDateTime
                CommentLabel
                CapturedDateTimeLabel
            }
        }
    }
}

query CHECK_INVOICES_IF_SINGLE_CUSTOMER(
    $InvoiceState: String
    $InvoiceNumber: String
    $Customer: String
    $CustomerCode: String
    $CustomerCountry: String
    $CustomerState: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $DueDateMin: String
    $DueDateMax: String
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $InvoiceIds: [ID]
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $IsBlocked: Boolean
    $CustomerId: ID
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    CheckInvoicesIfSingleCustomer(
        Filter: {
            InvoiceState: $InvoiceState
            InvoiceNumber: $InvoiceNumber
            Customer: $Customer
            CustomerCode: $CustomerCode
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            DueDateMin: $DueDateMin
            DueDateMax: $DueDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            InvoiceIds: $InvoiceIds
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            IsBlocked: $IsBlocked
            CustomerId: $CustomerId
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        IsSingleCustomer
        Customer {
            Id
        }
    }
}

query GET_TRIGGERS_FOR_WORKFLOW_STATE(
    $WorkflowId: ID
    $StateName: String
    $CompanyId: ID
) {
    GetTriggersForWorkflowState(
        Filter: { 
            WorkflowId: $WorkflowId
            StateName: $StateName
            CompanyId: $CompanyId
        }
    ) {
        WorkflowTransitions {
            Trigger
            DataCapture {
                CaptureDateTime
                DateTimeLabel
                CaptureComment
                CommentLabel
            }
        }
    }
}

query GET_TRIGGERS_FOR_WORKFLOW_STATES(
    $CompanyId: ID
    $WorkflowStates: [WorkflowStatesInput]
) {
    GetTriggersForWorkflowStates(
        Filter: { 
            CompanyId: $CompanyId
            WorkflowStates: $WorkflowStates
        }
    ) {
        WorkflowTransitions {
            Trigger
            DataCapture {
                CaptureDateTime
                DateTimeLabel
                CaptureComment
                CommentLabel
            }
        }
    }
}

query GET_REMITTANCE_ADVICES_FOR_COMPANY(
        $CustomerId: ID
        $RemittanceAdviceState: Int
        $PaidDateMin: String
        $PaidDateMax: String
        $PaidAmountMin: String
        $PaidAmountMax: String
        $AmountValue: Float
        $AmountOperator: String
        $AmountType: String
        $Customer: String
        $CustomerCode: String
        $CustomFieldFilters: String
        $CustomFieldMultipleValuesFilters: String
        $CustomFieldSort: String
        $SortField: String
        $Ascending: Boolean
        $AmountType: String
        $Skip: Int
        $PageSize: Int
        $IsCloudImportType: Boolean = false
        $MultipleCustomer: Boolean
        $CustomerFirstLetter: [String]
        $ActiveState: String
        $ViewAssociatedCustomers: Boolean = false
    ) {
    GetRemittanceAdvicesForCompany(
        Filter: { 
            CustomerId: $CustomerId
            RemittanceAdviceState: $RemittanceAdviceState
            PaidDateMin: $PaidDateMin
            PaidDateMax: $PaidDateMax
            PaidAmountMin: $PaidAmountMin
            PaidAmountMax: $PaidAmountMax
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            AmountType: $AmountType
            Customer: $Customer
            CustomerCode: $CustomerCode
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            SortField: $SortField
            Ascending: $Ascending
            AmountType: $AmountType
            Skip: $Skip
            PageSize: $PageSize
            MultipleCustomer: $MultipleCustomer
            CustomerFirstLetter: $CustomerFirstLetter
            ActiveState: $ActiveState
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        RemittanceAdvices {
            Id
            CompanyId
            Customer {
                ...CustomerFragment
            }
            Status
            ReceivedDate
            LocalReceivedDate
            PaidDate
            LocalPaidDate
            Amount
            AllocatedAmount
            MultipleCustomer
            ConversationLine {
                Id
                CompanyId
                CreatedDateTime
                Type
                TypeClassification
                Content
                Context
                DisplayName
                User {
                    UserId
                    GivenName
                    FamilyName
                    Email
                    PhoneNumber
                }
                ExternalEmailAddress
            }
            Uri
            Attachments{
                ...AttachmentFragment
            }
            InvoicesAllocated
            CreditsAllocated
            RebatesAllocated
            WithOverpayments
            WithOverclaims
            IsLocked
            SalesOrdersAllocated
        }
    }
}

query UPDATE_NOTIFICATION_IS_READ_FLAG(
    $CategoryId: ID
    $NotificationId: ID
) {
    UpdateNotificationIsReadFlag(
        Filter: { 
            CategoryId: $CategoryId
            NotificationId: $NotificationId 
        }
    )
}

query GET_TASK_HISTORY_ACTIONED_TICKET_DETAILS(
    $BatchId: ID
    $CompanyId: ID
    $IsCloudImportType: Boolean = false
) {
    GetTaskHistoryActionedTicketDetails(
        BatchId: $BatchId
        CompanyId: $CompanyId
    ) {
        TaskHistoryActionedTicketDetailsList{
            CompanyId
            Action
            Comment
            CommentLabel
            CapturedDateTime
            CapturedDateTimeLabel
            CreatedDateTime
            Ticket {
                Id
                TicketNumber
                State
                Details
                ResolvedReason
                ResolvedDateTime
                CreatedDateTime
                TicketOption {
                    ...TicketOptionFragment
                }
                Customer {
                    ...CustomerFragment
                }
                ClosedBy {
                    GivenName
                    FamilyName
                }
                ExternalEmailAddress
                Uri
                Attachments {
                    ...AttachmentFragment
                }
            }
            User {
                GivenName
                FamilyName
            }
            AssignedEmailAddress
        }
    }
}

query GET_TASK_HISTORY_ACTIONED_PAYMENT_PLAN_DETAILS(
    $BatchId: ID
    $CompanyId: ID
) {
    GetTaskHistoryActionedPaymentPlanDetails(
        BatchId: $BatchId
        CompanyId: $CompanyId
    ) {
        Action
        Comment
        CommentLabel
        CapturedDateTime
        CapturedDateTimeLabel
        CreatedDateTime
        PaymentPlan {
            Id
            State
            InvoiceIds
            TotalAmount
            AmountRemaining
            LocalRequestedDateTime
            LocalApprovedDateTime
            Number
            LocalClosedDateTime
            TotalSchedules
            Frequency
            PaymentPlanSchedules {
                Id
                PaymentPlanId
                Number
                State
                TotalAmount
                AmountRemaining
                LocalDueDateTime
                DueDateTime
                LocalClosedDateTime
            }
            ClosedComment
        }
        User {
            GivenName
            FamilyName
        }
        AssignedEmailAddress
    }
}

query GET_TASK_HISTORY_ACTIONED_CANCEL_PAYMENT_PLAN_DETAILS(
    $CompanyId: ID
	$BatchId: ID
	$SortField: String
	$ThenSortField: String
	$Ascending: Boolean
	$Skip: Int
	$PageSize: Int
    $IsCloudImportType: Boolean = false
) {
    GetTaskHistoryActionedCancelPaymentPlanDetails(
        Filter: {
            CompanyId: $CompanyId
            SortField: $SortField
            BatchId: $BatchId
            Skip: $Skip
            PageSize: $PageSize
            ThenSortField: $ThenSortField
            Ascending: $Ascending
        }
    ) {
        TaskHistoryActionedCancelPaymentPlanList {
            Action
            Comment
            CommentLabel
            CapturedDateTime
            CapturedDateTimeLabel
            CreatedDateTime
            PaymentPlan {
                Id
                State
                InvoiceIds
                TotalAmount
                AmountRemaining
                LocalRequestedDateTime
                LocalApprovedDateTime
                Number
                LocalClosedDateTime
                TotalSchedules
                Frequency
                PaymentPlanSchedules {
                    Id
                    PaymentPlanId
                    Number
                    State
                    TotalAmount
                    AmountRemaining
                    LocalDueDateTime
                    DueDateTime
                    LocalClosedDateTime
                }
                ClosedComment
            }
            User {
                GivenName
                FamilyName
            }
            AssignedEmailAddress
            Customer {
                ...CustomerFragment
            }
        }
    }
}

query GET_TASK_HISTORY_ACTIONED_PAYMENT_DETAILS(
    $CompanyId: ID
    $BatchId: ID
    $IsCloudImportType: Boolean = false
) {
    GetTaskHistoryActionedPaymentDetails(
        CompanyId: $CompanyId
        BatchId: $BatchId
    ) {
        TaskHistoryActionedPaymentDetailsList{
            CompanyId
            Action
            State
            Comment
            CreatedDateTime
            Payment {
                ...PaymentFragment
            }
            RemittanceAdvice {
                Id
                CompanyId
                Customer {
                    ...CustomerFragment
                }
                Status
                ReceivedDate
                LocalReceivedDate
                PaidDate
                LocalPaidDate
                Amount
                AllocatedAmount
                MultipleCustomer
                ConversationLine {
                    Id
                    CompanyId
                    CreatedDateTime
                    Type
                    TypeClassification
                    Content
                    Context
                    DisplayName
                    User {
                        UserId
                        GivenName
                        FamilyName
                        Email
                        PhoneNumber
                    }
                    ExternalEmailAddress
                }
                Uri
                Attachments{
                    ...AttachmentFragment
                }
                InvoicesAllocated
                CreditsAllocated
            }
            User {
                GivenName
                FamilyName
            }
            AssignedEmailAddress
        }
    }
}

query GET_ACTIONED_PAYMENT_BEHAVIOUR_INSIGHT_DETAILS(
    $BatchId: ID
    $CompanyId: ID
) {
    GetTaskHistoryActionedPaymentBehaviourInsights(
        BatchId: $BatchId
        CompanyId: $CompanyId
    ) {
        CompanyId
        Action
        Comment
        CreatedDateTime
        User {
            GivenName
            FamilyName
        }
        AssignedEmailAddress
    }
}

query GET_ACTIONED_PHONE_CALL_TASK_DETAILS(
    $BatchId: ID
    $CompanyId: ID
    $UsingInvoiceWorkflow: Boolean!
    $IsCloudImportType: Boolean = false
) {
    GetTaskHistoryActionedPhoneCallDetails(
        BatchId: $BatchId
        CompanyId: $CompanyId
    ) {
        CompanyId
        Action
        Comment
        CreatedDateTime
        PromiseToPayDate
        User {
          GivenName
          FamilyName
        }
        AssignedEmailAddress
        Customer {
          ...CustomerFragment
        }
        Invoice @include(if: $UsingInvoiceWorkflow) {
            AgedTrialBalanceFromCreate {
                ...AgedTrialBalanceFromCreateFragment
            }
            AgedTrialBalanceFromDue {
                ...AgedTrialBalanceFromDueFragment
            }
            CreatedDate
            LocalCreatedDate
            DueDate
            LocalDueDate
            Number
            OriginalAmount
            AmountOwing
            CustomFields {
                ...CustomFieldFragment
            }
            Attachments {
                ...AttachmentFragment
            }
            Uri
            GlCode
        }
    }
}

query GET_CONVERSATION_LINES_FOR_COMPANY(
    $CompanyId: ID
    $Type: Int
    $ResourceScopes: [ResourceScopeInput]
    $CreatedDateMin: String
    $CreatedDateMax: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $IsCloudImportType: Boolean = false
    $FetchResource: Boolean = false
    $IsCalendarView: Boolean = false
) {
    GetConversationLinesForCompany(
        Filter: {
            CompanyId: $CompanyId
            Type: $Type
            ResourceScopes: $ResourceScopes
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            IsCalendarView: $IsCalendarView
        }
    ) {
        ConversationLines {
            Id
            CompanyId
            CreatedDateTime
            Type
            TypeClassification
            Content
            Context
            DisplayName
            User {
                UserId
                GivenName
                FamilyName
                Email
                PhoneNumber
            }
            ExternalEmailAddress
            PrimaryResource {
                Uri
                ...ResourceFragment
            }
        }
    }
}

query GET_CONVERSATION_LINES_FOR_ORGANISATION(
    $Type: Int
    $ResourceScopes: [ResourceScopeInput]
    $CompanyIds: [ID]
    $CreatedDateMin: String
    $CreatedDateMax: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
) {
    GetConversationLinesForOrganisation(
        Filter: {
            Type: $Type
            ResourceScopes: $ResourceScopes
            CompanyIds: $CompanyIds
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
        }
    ) {
        ConversationLines {
            Id
            CompanyId
            CreatedDateTime
            Type
            TypeClassification
            Content
            Context
            DisplayName
            User {
                UserId
                GivenName
                FamilyName
                Email
                PhoneNumber
            }
            ExternalEmailAddress
        }
    }
}

query GET_CHAT_FOR_COMPANY(
    $CompanyId: ID
    $Type: Int
    $ResourceScopes: [ResourceScopeInput]
    $CreatedDateMin: String
    $CreatedDateMax: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
) {
    GetConversationResourcesForCompany(
        Filter: {
            CompanyId: $CompanyId
            Type: $Type
            ResourceScopes: $ResourceScopes
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
        }
    ) {
        ConversationLines {
            Id
            CompanyId
            CreatedDateTime
            Type
            TypeClassification
            Content
            Context
            DisplayName
            User {
                UserId
                GivenName
                FamilyName
                Email
                PhoneNumber
            }
            ExternalEmailAddress
            PrimaryResource {
                Uri
            }
            AttachmentId
            Attachment {
                ...AttachmentFragment
            }
        }
    }
}

query GET_PAGE_VIEWS($PageName: String) {
    GetPageViews(PageName: $PageName) {
        Views {
            Id
            CreatedUser {
                UserId
                GivenName
                FamilyName
            }
            Name
            Category
            FilterState
            DashboardState
            IsDefaultView,
            IsCustomerPortalView
        }
    }
}

query GET_API_USERS_FOR_COMPANY {
    GetApiUsersForCompany {
        ApiUsers {
            CompanyId
            Role {
                RoleId
                Name
            }
            Name
            ParentUser {
                UserId
                GivenName
                FamilyName
            }
            Active
            Key
            CreatedDateTime
        }
    }
}

query GET_CHANGE_LINES_FOR_COMPANY(
    $CompanyId: ID
    $Resource: ResourceInput
    $AssociatedResource: ResourceInput
    $Type: Int
    $ResourceTypes: [String]
    $SourceTypes: [Int]
    $CreatedDateTimeMin: String
    $CreatedDateTimeMax: String
    $Skip: Int
    $PageSize: Int
    $IsCloudImportType: Boolean = false
    $FetchResource: Boolean = false
    $IsCalendarView: Boolean = false
    $ChangeUserId: ID
) {
    GetChangeLinesForCompany(
        Filter: { 
            CompanyId: $CompanyId
            Resource: $Resource
            AssociatedResource: $AssociatedResource
            Type: $Type
            ResourceTypes: $ResourceTypes
            SourceTypes: $SourceTypes
            CreatedDateTimeMin: $CreatedDateTimeMin
            CreatedDateTimeMax: $CreatedDateTimeMax
            Skip: $Skip 
            PageSize: $PageSize
            IsCalendarView: $IsCalendarView
            ChangeUserId: $ChangeUserId
        }
    ) {
        ChangeLines {
            Id
            CompanyId
            CreatedDateTime
            Type
            DisplayName
            User {
                GivenName
                FamilyName
                Email
                PhoneNumber
            }
            Context
            Resource {
                ...ResourceFragment
            }
            AssociatedResource {
                ...ResourceFragment
            }
            Source
            Allocation {
                ToResource {
                    ...ResourceFragment
                }
                AmountAllocated
                IsDiscount
                IsOverclaim
            }
            ChangeSets {
                FieldName
                BeforeValue
                AfterValue
            }
            IsReversed
        }
    }
}

query GET_CHANGE_LINES_FOR_ORGANISATION(
    $Resource: ResourceInput
    $AssociatedResource: ResourceInput
    $Type: Int
    $ResourceTypes: [String]
    $SourceTypes: [Int]
    $CreatedDateTimeMin: String
    $CreatedDateTimeMax: String
    $Skip: Int
    $PageSize: Int
    $Countries: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $UserId: ID
    $OrganisationId: ID
    $IsCloudImportType: Boolean = false
    $FetchResource: Boolean = false
    $IsCalendarView: Boolean = false
) {
    GetChangeLinesForOrganisation(
        Filter: { 
            Resource: $Resource
            AssociatedResource: $AssociatedResource
            Type: $Type
            ResourceTypes: $ResourceTypes
            SourceTypes: $SourceTypes
            CreatedDateTimeMin: $CreatedDateTimeMin
            CreatedDateTimeMax: $CreatedDateTimeMax
            Skip: $Skip
            PageSize: $PageSize
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            UserId: $UserId
            OrganisationId: $OrganisationId
            IsCalendarView: $IsCalendarView
        }
    ) {
        ChangeLines {
            Id
            CompanyId
            CreatedDateTime
            Type
            DisplayName
            User {
                GivenName
                FamilyName
                Email
                PhoneNumber
            }
            Context
            Resource {
                ...ResourceFragment
            }
            AssociatedResource {
                ...ResourceFragment
            }
            Source
            Allocation {
                ToResource {
                    ...ResourceFragment
                }
                AmountAllocated
            }
            ChangeSets {
                FieldName
                BeforeValue
                AfterValue
            }
            IsReversed
        }
    }
}

query GET_CHANGE_COUNT_BY_SOURCE_FOR_COMPANY(
    $CompanyId: ID
    $Type: Int
    $ResourceTypes: [String]
    $SourceTypes: [Int]
    $CreatedDateTimeMin: String
    $CreatedDateTimeMax: String
) {
    GetChangeCountBySourceForCompany(
        Filter: { 
            CompanyId: $CompanyId
            Type: $Type
            ResourceTypes: $ResourceTypes
            SourceTypes: $SourceTypes
            CreatedDateTimeMin: $CreatedDateTimeMin
            CreatedDateTimeMax: $CreatedDateTimeMax
        }
    ) {
        ChangeSourceCounts {
            Count
            User {
                GivenName
                FamilyName
            }
        }
    }
}

query GET_CUSTOMER_COUNT_PBI_FOR_COMPANY(
    $CompanyId: ID
) {
    GetCustomerCountPBIForCompany(
        Filter: { 
            CompanyId: $CompanyId
        }
    ) {
        CustomerCountPaymentBehaviourInsights {
            Count
            Description
        }
    }
}

query GET_CUSTOMER_COUNT_PBI_FOR_ORGANISATION(
    $CompanyIds: [ID]
) {
    GetCustomerCountPBIForOrganisation(
        Filter: { 
            CompanyIds: $CompanyIds
        }
    ) {
        CustomerCountPaymentBehaviourInsights {
            Count
            Description
        }
    }
}

query GET_CUSTOMER_INSIGHTS_HISTORY_FOR_COMPANY(
    $CompanyId: ID
    $CustomerIds: [ID]
    $DateMin: String
    $DateMax: String
    $Customer: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
) {
    GetInsightCustomerHistoryForCompany(
        Filter: { 
            CompanyId: $CompanyId
            CustomerIds: $CustomerIds
            DateMin: $DateMin
            DateMax: $DateMax
            Customer: $Customer
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
        }
    ) {
        InsightCustomerHistoryReports {
            CustomerCode
            CustomerName
            January
            February
            March
            April
            May
            June
            July
            August
            September
            October
            November
            December
        }
    }
}

query GET_CUSTOMER_INSIGHTS_HISTORY_FOR_ORGANISATION(
    $CompanyIds: [ID]
    $CustomerIds: [ID]
    $DateMin: String
    $DateMax: String
    $Customer: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $Countries: [String]
	$Regions: [String]
	$OrganisationCurrencies: [OrganisationCurrencyInput]
    $ConversionCurrency: Float
) {
    GetInsightCustomerHistoryForOrganisation(
        Filter: { 
            CompanyIds: $CompanyIds
            CustomerIds: $CustomerIds
            DateMin: $DateMin
            DateMax: $DateMax
            Customer: $Customer
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            Countries: $Countries
            Regions: $Regions
            OrganisationCurrencies: $OrganisationCurrencies
            ConversionCurrency: $ConversionCurrency
        }
    ) {
        InsightCustomerHistoryReports {
            CustomerCode
            CustomerName
            January
            February
            March
            April
            May
            June
            July
            August
            September
            October
            November
            December
        }
    }
}
query GET_CHANGE_COUNT_BY_SOURCE_FOR_ORGANISATION(
    $Type: Int
    $ResourceTypes: [String]
    $SourceTypes: [Int]
    $CreatedDateTimeMin: String
    $CreatedDateTimeMax: String
    $Countries: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $UserId: ID
    $OrganisationId: ID
) {
    GetChangeCountBySourceForOrganisation(
        Filter: { 
            Type: $Type
            ResourceTypes: $ResourceTypes
            SourceTypes: $SourceTypes
            CreatedDateTimeMin: $CreatedDateTimeMin
            CreatedDateTimeMax: $CreatedDateTimeMax
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            UserId: $UserId
            OrganisationId: $OrganisationId
        }
    ) {
        ChangeSourceCounts {
            Count
            User {
                GivenName
                FamilyName
            }
        }
    }
}

query GET_CHANGE_COUNT_BY_SOURCE_TYPE_FOR_COMPANY(
    $CompanyId: ID
    $Type: Int
    $ResourceTypes: [String]
    $SourceTypes: [Int]
    $CreatedDateTimeMin: String
    $CreatedDateTimeMax: String
) {
    GetChangeCountBySourceTypeForCompany(
        Filter: { 
            CompanyId: $CompanyId
            Type: $Type
            ResourceTypes: $ResourceTypes
            SourceTypes: $SourceTypes
            CreatedDateTimeMin: $CreatedDateTimeMin
            CreatedDateTimeMax: $CreatedDateTimeMax
        }
    ) {
        ChangeSourceTypeCounts {
            Count 
            SourceType
        }
    }
}

query GET_CHANGE_COUNT_BY_SOURCE_TYPE_FOR_ORGANISATION(
    $Type: Int
    $ResourceTypes: [String]
    $SourceTypes: [Int]
    $CreatedDateTimeMin: String
    $CreatedDateTimeMax: String
    $Countries: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $UserId: ID
    $OrganisationId: ID
) {
    GetChangeCountBySourceTypeForOrganisation(
        Filter: { 
            Type: $Type
            ResourceTypes: $ResourceTypes
            SourceTypes: $SourceTypes
            CreatedDateTimeMin: $CreatedDateTimeMin
            CreatedDateTimeMax: $CreatedDateTimeMax
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            UserId: $UserId
            OrganisationId: $OrganisationId
        }
    ) {
        ChangeSourceTypeCounts {
            Count 
            SourceType
        }
    }
}

query CHECK_LAST_PAYMENT_CHANGELINES(
    $Resource: ResourceInput
    $AssociatedResource: ResourceInput
    $Type: Int
    $CompanyId: ID
) {
    CheckLastPaymentChangeLines(
        Filter: { 
            Resource: $Resource
            AssociatedResource: $AssociatedResource
            Type: $Type
            CompanyId: $CompanyId
        }
    ) {
        IsLastPaymentChangeline
    }
}

query GET_TASK_COUNT_BY_STATE_NAME(
    $CompanyId: ID
    $DisplayName: String
    $CustomerCode: String
    $InvoiceNumber: String
    $AmountValue: Float
    $AmountOperator: String
    $ActionDateMin: AWSDateTime
    $ActionDateMax: AWSDateTime
    $CreatedDateMin: AWSDateTime
    $CreatedDateMax: AWSDateTime
    $Type: Int
    $CustomerCountry: String
    $CustomerState: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $WorkflowFilters: [WorkflowFilterInput]
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTaskCountByStateName(
        Filter: { 
            CompanyId: $CompanyId
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            InvoiceNumber: $InvoiceNumber
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            ActionDateMin: $ActionDateMin
            ActionDateMax: $ActionDateMax
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            Type: $Type
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            WorkflowFilters: $WorkflowFilters
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TaskCountStateNames {
            Count
            StateName
        }
    }
}

query GET_TASK_COUNT_BY_USER(
    $CompanyId: ID
    $DisplayName: String
    $CustomerCode: String
    $InvoiceNumber: String
    $AmountValue: Float
    $AmountOperator: String
    $ActionDateMin: AWSDateTime
    $ActionDateMax: AWSDateTime
    $CreatedDateMin: AWSDateTime
    $CreatedDateMax: AWSDateTime
    $Type: Int
    $CustomerCountry: String
    $CustomerState: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $WorkflowFilters: [WorkflowFilterInput]
    $Status: Int
    $Contact: Int
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTaskCountByUserForCompany(
        Filter: {
            CompanyId: $CompanyId
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            InvoiceNumber: $InvoiceNumber
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            ActionDateMin: $ActionDateMin
            ActionDateMax: $ActionDateMax
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            Type: $Type
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            WorkflowFilters: $WorkflowFilters
            Status: $Status
            Contact: $Contact
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TaskUserCounts {
            Count
	        User {
                UserId
                GivenName
                FamilyName
                Email
                CreatedDateTime
            }
	        AssignedEmailAddress
        }
    }
}

query GET_TASK_COUNT_BY_USER_TYPE(
    $CompanyId: ID
    $DisplayName: String
    $CustomerCode: String
    $InvoiceNumber: String
    $AmountValue: Float
    $AmountOperator: String
    $ActionDateMin: AWSDateTime
    $ActionDateMax: AWSDateTime
    $CreatedDateMin: AWSDateTime
    $CreatedDateMax: AWSDateTime
    $Type: Int
    $CustomerCountry: String
    $CustomerState: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $WorkflowFilters: [WorkflowFilterInput]
    $Status: Int
    $Contact: Int
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTaskCountByUserTypeForCompany(
        Filter: { 
            CompanyId: $CompanyId
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            InvoiceNumber: $InvoiceNumber
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            ActionDateMin: $ActionDateMin
            ActionDateMax: $ActionDateMax
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            Type: $Type
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters,
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            WorkflowFilters: $WorkflowFilters
            Status: $Status
            Contact: $Contact
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TaskUserTypeCounts {
            Count
	        UserType
        }
    }
}

query GET_TICKET_COUNT_BY_STATUS(
    $CompanyId: ID
    $DisplayName: String
    $CustomerCode: String
    $CustomerId: ID
    $CustomerCountry: String
    $CustomerState: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $ClosedDateMin: String
    $ClosedDateMax: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $TicketOptionReasons: [String]
    $Status: Int
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTicketCountByStatus(
        Filter: { 
            CompanyId: $CompanyId
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            CustomerId: $CustomerId
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            ClosedDateMin: $ClosedDateMin
            ClosedDateMax: $ClosedDateMax
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            TicketOptionReasons: $TicketOptionReasons
            Status: $Status
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        OpenSum
    }
}

query GET_SALES_REPORT_FOR_COMPANY(
    $CompanyId: ID
    $DateMin: String
    $DateMax: String
    $IsMonthlyView: Boolean
    $DisplayOption: String
    $IsCreatedDateView: Boolean
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $Countries: [String]
    $Postcodes: [String]
    $Customer: String
    $IsCalendarView: Boolean
    $CustomerId: ID
    $ViewAssociatedCustomers: Boolean = false
) {
    GetSalesReportForCompany(
        Filter: {
            CompanyId: $CompanyId
            DateMin: $DateMin
            DateMax: $DateMax
            IsMonthlyView: $IsMonthlyView
            DisplayOption: $DisplayOption
            IsCreatedDateView: $IsCreatedDateView
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            Countries: $Countries
            Postcodes: $Postcodes
            Customer: $Customer
            IsCalendarView: $IsCalendarView
            CustomerId: $CustomerId
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        Sales {
            AmountOwing
            AmountPaid
            DisplayPeriod
            Year
        }
    }
}

query GET_NOTIFICATION_SUCCESS_REPORT(
    $CompanyId: ID
    $DateMin: String
    $DateMax: String
    $IsMonthlyView: Boolean
    $DisplayOption: String
    $IsCreatedDateView: Boolean
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $Countries: [String]
    $Postcodes: [String]
    $Customer: String
    $CustomerId: ID
    $ViewAssociatedCustomers: Boolean = false
) {
    GetNotificationSuccessReport(
        Filter: {
            CompanyId: $CompanyId
            DateMin: $DateMin
            DateMax: $DateMax
            IsMonthlyView: $IsMonthlyView
            DisplayOption: $DisplayOption
            IsCreatedDateView: $IsCreatedDateView
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            Countries: $Countries
            Postcodes: $Postcodes
            Customer: $Customer
            CustomerId: $CustomerId
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        NotificationSuccesses {
            StateName
            OriginalAmount
            AmountPaid
            PercentageRecovered
        }
        InvoiceTotal
        AmountPaidTotal
        PercentageRecoveredTotal
    }
}

query GET_INVOICING_SETTLEMENT_REPORT(
    $CompanyId: ID
    $DateMin: String
    $DateMax: String
    $IsMonthlyView: Boolean
    $DisplayOption: String
    $IsCreatedDateView: Boolean
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $Countries: [String]
    $Postcodes: [String]
    $Customer: String
    $CustomerId: ID
    $ViewAssociatedCustomers: Boolean = false
) {
    GetInvoicingSettlementReport(
        Filter: {
            CompanyId: $CompanyId
            DateMin: $DateMin
            DateMax: $DateMax
            IsMonthlyView: $IsMonthlyView
            DisplayOption: $DisplayOption
            IsCreatedDateView: $IsCreatedDateView
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            Countries: $Countries
            Postcodes: $Postcodes
            Customer: $Customer
            CustomerId: $CustomerId
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        InvoicingSettlements {
            OriginalAmount
            InvoicingSettlementType
            DisplayPeriod
            Year
        }
    }
}

query GET_TICKET_COUNT_BY_GROUPING(
    $CompanyId: ID
    $DisplayName: String
    $CustomerCode: String
    $CustomerCountry: String
    $CustomerState: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $ClosedDateMin: String
    $ClosedDateMax: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $TicketOptionReasons: [String]
    $Status: Int = -1
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTicketCountByGrouping(
        Filter: {
            CompanyId: $CompanyId
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            ClosedDateMin: $ClosedDateMin
            ClosedDateMax: $ClosedDateMax
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            TicketOptionReasons: $TicketOptionReasons
            Status: $Status
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TicketCounts {
            OpenSum
            ClosedSum
            State
            Reason
        }
    }
}

query GET_TICKET_COUNT_BY_USER_FOR_COMPANY(
    $CompanyId: ID
    $DisplayName: String
    $CustomerIds: [ID]
    $CustomerCode: String
    $CustomerCountry: String
    $CustomerState: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $ClosedDateMin: String
    $ClosedDateMax: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $TicketOptionReasons: [String]
    $Status: Int = -1
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTicketCountByUserForCompany(
        Filter: {
            CompanyId: $CompanyId
            DisplayName: $DisplayName
            CustomerIds: $CustomerIds
            CustomerCode: $CustomerCode
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            ClosedDateMin: $ClosedDateMin
            ClosedDateMax: $ClosedDateMax
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            TicketOptionReasons: $TicketOptionReasons
            Status: $Status
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TicketUserCounts {
            OpenSum
            ClosedSum
            User {
                UserId
                GivenName
                FamilyName
                Email
                CreatedDateTime
            }
	        AssignedEmailAddress
        }
    }
}

query GET_TICKET_COUNT_BY_USER_TYPE_FOR_COMPANY(
    $CompanyId: ID
    $DisplayName: String
    $CustomerCode: String
    $CustomerCountry: String
    $CustomerState: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $ClosedDateMin: String
    $ClosedDateMax: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $TicketOptionReasons: [String]
    $Status: Int = -1
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTicketCountByUserTypeForCompany(
        Filter: {
            CompanyId: $CompanyId
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            ClosedDateMin: $ClosedDateMin
            ClosedDateMax: $ClosedDateMax
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            TicketOptionReasons: $TicketOptionReasons
            Status: $Status
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TicketUserTypeCounts {
            OpenSum
            ClosedSum
            UserType
        }
    }
}

query GET_TOTAL_OWED_REPORT(
    $CompanyId: ID
    $DisplayOption: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $Customer: String
    $IsCalendarView: Boolean
    $CustomerId: ID
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTotalOwedReport(
        Filter: {
            CompanyId: $CompanyId
            DisplayOption: $DisplayOption
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            Customer: $Customer
            IsCalendarView: $IsCalendarView
            CustomerId: $CustomerId
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TotalAmountOwing
    }
}

query GET_NOTIFICATIONS_REPORT(
    $CompanyId: ID
    $DateMin: String
    $DateMax: String
    $IsMonthlyView: Boolean
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $Countries: [String]
    $Postcodes: [String]
    $Customer: String
    $CustomerId: ID
    $ViewAssociatedCustomers: Boolean = false
) {
    GetNotificationReport(
        Filter: {
            CompanyId: $CompanyId
            DateMin: $DateMin
            DateMax: $DateMax
            IsMonthlyView: $IsMonthlyView
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            Countries: $Countries
            Postcodes: $Postcodes
            Customer: $Customer
            CustomerId: $CustomerId
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        Notifications {
            CountType
            Count
            DisplayPeriod
            Year
        }
    }
}

query GET_PAYMENTS_FOR_COMPANY(
    $CompanyId: ID
    $Customer: String
    $CustomerCode: String
    $Result: Int
    $PaidDateMin: String
    $PaidDateMax: String
    $SettlementDateMin: String
    $SettlementDateMax: String
    $AmountValue: String
    $AmountOperator: String
    $AmountType: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CustomFieldFilters: String
    $BankInstitutions: [String]
    $CustomFieldSort: String
    $IsCloudImportType: Boolean = false
    $CustomerFirstLetter: [String]
    $CustomFieldMultipleValuesFilters: String
    $ActiveState: String
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetPaymentsForCompany(
        Filter: {
            CompanyId: $CompanyId
            Customer: $Customer
            CustomerCode: $CustomerCode
            Result: $Result
            PaidDateMin: $PaidDateMin
            PaidDateMax: $PaidDateMax
            SettlementDateMin: $SettlementDateMin
	        SettlementDateMax: $SettlementDateMax
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            AmountType: $AmountType
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            BankInstitutions: $BankInstitutions
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldSort: $CustomFieldSort
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomerFirstLetter: $CustomerFirstLetter
            ActiveState: $ActiveState
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        Payments {
            ...PaymentFragment
            # Allocations {
            #    AmountAllocated
            # }
        }
    } 
}

query GET_PAYMENTS_FOR_ORGANISATION(
    $Customer: String
    $CustomerCode: String
    $Result: Int
    $PaidDateMin: String
    $PaidDateMax: String
    $AmountValue: String
    $AmountOperator: String
    $AmountType: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $IsCloudImportType: Boolean = false
    $Countries: [String]
	$Regions: [String]
	$CompanyIds: [ID]
	$OrganisationCurrencies: [OrganisationCurrencyInput]
	$ConversionCurrency: Float
    $UserId: ID
    $OrganisationId: ID
    $CustomerFirstLetter: [String]
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetPaymentsForOrganisation(
        Filter: {
            Customer: $Customer
            CustomerCode: $CustomerCode
            Result: $Result
            PaidDateMin: $PaidDateMin
            PaidDateMax: $PaidDateMax
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            AmountType: $AmountType
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            OrganisationCurrencies: $OrganisationCurrencies
            ConversionCurrency: $ConversionCurrency
            UserId: $UserId
            OrganisationId: $OrganisationId
            CustomerFirstLetter: $CustomerFirstLetter
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        Payments {
            ...PaymentFragment
            # Allocations {
            #    AmountAllocated
            # }
        }
    }
}

query GET_PAYMENTS_ALLOCATION_FOR_COMPANY(
    $CompanyId: ID
    $Customer: String
    $CustomerCode: String
    $PaidDateMin: String
    $PaidDateMax: String
    $AmountValue: String
    $AmountOperator: String
    $AmountType: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetPaymentAllocationTotalForCompany(
        Filter: {
            CompanyId: $CompanyId
            Customer: $Customer
            CustomerCode: $CustomerCode
            PaidDateMin: $PaidDateMin
            PaidDateMax: $PaidDateMax
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            AmountType: $AmountType
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TotalPaidAmount
        TotalAllocatedAmount
        TotalUnallocatedAmount
    }
}

query GET_PAYMENTS_ALLOCATION_FOR_ORGANISATION(
    $Customer: String
    $CustomerCode: String
    $PaidDateMin: String
    $PaidDateMax: String
    $AmountValue: String
    $AmountOperator: String
    $AmountType: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $Countries: [String]
	$Regions: [String]
	$CompanyIds: [ID]
	$OrganisationCurrencies: [OrganisationCurrencyInput]
	$ConversionCurrency: Float
    $UserId: ID
    $OrganisationId: ID
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetPaymentAllocationTotalForOrganisation(
        Filter: {
            Customer: $Customer
            CustomerCode: $CustomerCode
            PaidDateMin: $PaidDateMin
            PaidDateMax: $PaidDateMax
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            AmountType: $AmountType
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            OrganisationCurrencies: $OrganisationCurrencies
            ConversionCurrency: $ConversionCurrency
            UserId: $UserId
            OrganisationId: $OrganisationId
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TotalPaidAmount
        TotalAllocatedAmount
        TotalUnallocatedAmount
    }
}

query GET_PAYMENT_DETAILS_FOR_COMPANY(
    $CompanyId: ID
    $PaymentId: ID
    $IsCloudImportType: Boolean = false
) {
    GetPaymentDetailsForCompany(
        PaymentId: $PaymentId,
        CompanyId: $CompanyId
    ) {
        ...PaymentFragment
        # Allocations {
        #    AmountAllocated
        #    ToResource {
        #        Uri
        #    }
        # }
    }
}

query GET_PAYMENT_DETAILS_FOR_COMPANY_PUBLIC(
    $PaymentId: ID
    $CompanyId: ID
) {
    GetPublicPaymentDetails(
        Filter: { 
            PaymentId: $PaymentId
            CompanyId: $CompanyId
        }
    ) {
        Id
        Allocations {
            ToResource {
                Uri
            }
        }
    }
}

query GET_ALLOCATED_INVOICES_FOR_PAYMENT(
    $PaymentId : ID
    $InvoiceState: String
    $InvoiceNumber: String
    $CustomerId: ID
    $Customer: String
    $CustomerCode: String
    $CustomerCountry: String
    $CustomerState: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $DueDateMin: String
    $DueDateMax: String
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CompanyId: ID
    $IsCloudImportType: Boolean = false
    $Type: String
) {
    GetAllocatedInvoicesForPayment (
        PaymentId: $PaymentId
        Filter: {
            InvoiceState: $InvoiceState
            InvoiceNumber: $InvoiceNumber
            CustomerId: $CustomerId
            Customer: $Customer
            CustomerCode: $CustomerCode
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            DueDateMin: $DueDateMin
            DueDateMax: $DueDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CompanyId: $CompanyId
            Type: $Type
        }
    ) {
        PaymentInvoices {
            Invoice {
                ...InvoiceFragment
            }
            Customer {
                ...CustomerFragment
            }
            Number
            Amount
            PaymentId
        }
    }
}

query GET_BANK_FILE_FORMATS_FOR_COMPANY {
    GetBankFileFormatsForCompany 
}

query GET_XERO_CONFIGURATION_FOR_IMPORT {
    GetXeroConfigurationForImport {
        CompanyId
        ConnectionId
        TenantName
        XeroUser {
            UserId
            UserName
        }
    }
}

query GET_INVOICE_SET_BLOCKED_STATE(
    $InvoiceState: String
    $InvoiceNumber: String
    $Customer: String
    $CustomerCode: String
    $CustomerCountry: String
    $CustomerState: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $DueDateMin: String
    $DueDateMax: String
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $InvoiceIds: [ID]
    $ExcludeInvoices: Boolean
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $IsBlocked: Boolean
    $CustomerId: ID
	$CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetInvoiceSetBlockedState(
        Filter: {
            InvoiceState: $InvoiceState
            InvoiceNumber: $InvoiceNumber
            Customer: $Customer
            CustomerCode: $CustomerCode
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            DueDateMin: $DueDateMin
            DueDateMax: $DueDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            InvoiceIds: $InvoiceIds
            ExcludeInvoices: $ExcludeInvoices
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            IsBlocked: $IsBlocked
            CustomerId: $CustomerId
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        IsBlocked
        SetHasSameValue
    }
}

query GET_CUSTOMER_CURRENT_ATB_REPORT(
    $CompanyId: ID
    $IsCreatedDateView: Boolean
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $Countries: [String]
    $Postcodes: [String]
    $Customer: String
    $IsCalendarView: Boolean
    $IncludeManualItemsATB: Boolean
    $IncludeRebatesATB: Boolean
    $CustomerId: ID
    $ViewAssociatedCustomers: Boolean = false
) {
    GetCustomerCurrentATBReport(
        Filter: {
            CompanyId: $CompanyId
            IsCreatedDateView: $IsCreatedDateView
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            Countries: $Countries
            Postcodes: $Postcodes
            Customer: $Customer
            IsCalendarView: $IsCalendarView
            IncludeManualItemsATB: $IncludeManualItemsATB
            IncludeRebatesATB: $IncludeRebatesATB
            CustomerId: $CustomerId
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        Current
        CurrentPercentage
        Period1
        Period1Percentage
        Period2
        Period2Percentage
        Period3Plus
        Period3PlusPercentage
        NotDue
        NotDuePercentage
    }
}

query GET_PRODUCT_ANNOUNCEMENTS(
    $PublishDateTimeMax: String
    $PublishDateTimeMin: String
    $PageSize: Int
    $Skip: Int
) {
    GetProductAnnouncements(
        Filter: {
            PublishDateTimeMax: $PublishDateTimeMax
            PublishDateTimeMin: $PublishDateTimeMin
            PageSize: $PageSize
            Skip: $Skip
        }
    ) {
        ProductAnnouncements {
            ProductAnnouncementId
            Tag
            Title
            Body
            PublishDateTime
        }
    }
}

query GET_USER_PREFERENCE {
    GetUserPreference {
        UserId
        Preferences {
            PageName
            IsCompactView
        }
    }
}

query GET_INVOICE_CUSTOM_FIELD_VALUES(
    $FieldName: String
    $Value: String
) {
    GetInvoiceCustomFieldValues(
        Filter: { 
            FieldName: $FieldName
            Value: $Value 
        }
    )
}

query GET_ORGANISATION_INVOICE_CUSTOM_FIELD_VALUES(
    $FieldName: String
    $Value: String
    $CompanyIds: [ID]
) {
    GetOrganisationInvoiceCustomFieldValues(
        Filter: { 
            FieldName: $FieldName
            Value: $Value 
            CompanyIds: $CompanyIds
        }
    )
}

query GET_CUSTOMER_CUSTOM_FIELD_VALUES(
    $FieldName: String
    $Value: String
) {
    GetCustomerCustomFieldValues(
        Filter: { 
            FieldName: $FieldName
            Value: $Value
        }
    )
}

query GET_ORGANISATION_CUSTOMER_CUSTOM_FIELD_VALUES(
    $FieldName: String
    $Value: String
    $CompanyIds: [ID]
) {
    GetOrganisationCustomerCustomFieldValues(
        Filter: { 
            CompanyIds: $CompanyIds
            FieldName: $FieldName
            Value: $Value 
        }
    )
}

query GET_CREDIT_CUSTOM_FIELD_VALUES(
    $FieldName: String
    $Value: String
) {
    GetCreditCustomFieldValues(
        Filter: { 
            FieldName: $FieldName
            Value: $Value 
        }
    )
}

query GET_ORGANISATION_CREDIT_CUSTOM_FIELD_VALUES(
    $FieldName: String
    $Value: String
    $CompanyIds: [ID]
) {
    GetOrganisationCreditCustomFieldValues(
        Filter: { 
            FieldName: $FieldName
            Value: $Value
            CompanyIds: $CompanyIds
        }
    )
}

query GET_WORKFLOW_CONFIGURATION_FOR_COMPANY {
    GetWorkflowConfigurationForCompany {
        CompanyId
        Invoices {
	        WorkflowId
            CustomField {
                Name
                Value
            }
            InvoiceNumber
            CustomerCode
            CountryCode
            State
            WorkflowType
	        WorkflowName
        }
        Customers {
	        WorkflowId
            CustomField {
                Name
                Value
            }
            CustomerCode
            CountryCode
            State
            WorkflowType
	        WorkflowName
        }
    }
}

query GET_WORKFLOW_NAMES_FOR_COMPANY(
    $IncludePaymentPlanWorkflows: Boolean
    $IncludePaymentPlanApprovalWorkflows: Boolean
    $IncludeNewInvoiceWorkflows: Boolean
    $CompanyIds: [ID]
) {
    GetWorkflowNamesForCompany(
        IncludePaymentPlanWorkflows: $IncludePaymentPlanWorkflows
        IncludePaymentPlanApprovalWorkflows: $IncludePaymentPlanApprovalWorkflows
        IncludeNewInvoiceWorkflows: $IncludeNewInvoiceWorkflows
        CompanyIds: $CompanyIds
    ) {
        WorkflowId
        WorkflowName
        Type
    }
}

query GET_WORKFLOW_STEPS_FOR_COMPANY($WorkflowId: ID) {
    GetWorkflowStepsForCompany(WorkflowId: $WorkflowId)
}

query GET_WORKFLOW_DEFINITION($WorkflowId: ID) {
    GetWorkflowDefinition(WorkflowId: $WorkflowId) {
        WorkflowId
        Name
        EntityType
        AutoClose
        AutoCloseTrigger
        States {
            # IncludeCanceledInstallments
            Name
            Type
            Automation
            ReminderType
            IsSecondaryState
            NotDueGap
            IsEntryOrExit
            Transitions {
                DisplayName
                Trigger
                NewState
                MinimumAmount
                Events {
                    FunctionName
	                HandleCallback
                }
                Timing {
                    Orientation
                    Gap
                }
            }
            DeliveryMethod
            EmailContact
            {
                ToAddress
                CcAddress
                BccAddress
            }
        }
        Uri
    }
}

query GET_WORKFLOW_CONTENT_CONFIGURATION {
    GetWorkflowContentConfigurationForCompany {
        WorkflowId
        States {
            StateName
            EmailBodyTemplateKey
            EmailSubjectTemplateKey
            LetterTemplateKey
            SMSTemplateKey
        }
    }
}

query GET_CONTENT_TEMPLATE_CONFIGURATION($PaymentPlanEnabled: Boolean) {
    GetContentTemplateConfigurationForCompany(PaymentPlanEnabled: $PaymentPlanEnabled) {
        TemplateContents {
            TemplateName
            TemplateContentS3Key
        }
    }
}

query GET_CONTENT_TEMPLATE(
    $TemplateKey: String
    $ContentType: String
) {
    GetContentTemplateForCompany(
        TemplateKey: $TemplateKey
        ContentType: $ContentType
    ) {
        Content
        Payload
        Preview
    }
}

query GET_CONTENT_TEMPLATE_PREVIEW(
    $Content: String
    $Payload: String
    $ContentType: String
) {
    GetContentTemplatePreview(
        Content: $Content
        Payload: $Payload
        ContentType: $ContentType
    ) {
        Preview
    }
}

query GET_ORGANISATIONS_FOR_USER {
    GetOrganisationsForUser {
        Organisations {
            OrganisationId
            Name
            LogoPath
            DefaultCurrency {
                Name
                Value
                Rate
            }
            Currencies {
                Name
                Value
                Rate
            }
            SupportedRegions
        }
    }
}

query GET_ORGANISATION_COMPANIES(
    $CompanyName: String
    $IsClosed: Boolean
    $IncludeTotalUser: Boolean = false
) {
    GetOrganisationCompanies(
        Filter: { 
            CompanyName: $CompanyName
            IsClosed: $IsClosed 
        }
    ) {
        Companies {
            CompanyId
            Name
            LanguagePackage {
                Language
            }
            Region
            LogoPath
            CreatedDateTime
            Country
            IsClosed
            TotalUser @include(if: $IncludeTotalUser)
            SupportSendNewInvoice
            UsingCustomerWorkflow
            SupportCashAllocation
            CompanyPaymentPlan {
                IsEnabled
                Frequency
            }
            EnableExternalUserTaskAssignment
            EnablePaymentBehaviourInsights
        }
    }
}

query GET_ORGANISATION_COMPANIES_AUTOCOMPLETE_FILTER(
    $CompanyName: String
    $IsClosed: Boolean
) {
    GetOrganisationCompanies(
        Filter: { 
            CompanyName: $CompanyName
            IsClosed: $IsClosed 
        }
    ) {
        Companies {
            CompanyId
            Name
        }
    }
}

query GET_ORGANISATION_COMPANIES_FOR_USER {
    GetOrganisationCompaniesForUser {
        Companies {
            CompanyId
            Name
            LanguagePackage {
                Language
            }
            Region
            Country
            CustomFieldsConfigure {
                ...CompanyCustomFieldConfigureFragment
            }
            CompanyPaymentPlan {
                IsEnabled
                Frequency
            }
            SupportCashAllocation
            UsingCustomerWorkflow
            OrganisationId
            IsDueDateView
            IsCalendarView
            UsingMultipleWorkflow
            LockedDeliveryMethod
            EnableMultiFactorAuthentication
            CustomerTitleLabel
            SupportSendNewInvoice
            CommunicationMethod
            LanguageCode
            EnableBankFileImporting
            UsingCustomBankFileProcessor
            EnableMultiplePaymentPlanOptions
            EnablePaymentBehaviourInsights
        }
    }
}

query GET_TOTAL_OWED_REPORT_FOR_ORGANISATION(
    $DisplayOption: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $Regions: [String]
    $Countries: [String]
    $CompanyIds: [ID]
    $UserId: ID
    $OrganisationId: ID
    $Customer: String
    $IsCalendarView: Boolean
    $ConversionCurrency: Float
    $OrganisationCurrencies: [OrganisationCurrencyInput]
    $CustomerId: ID
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTotalOwedReportForOrganisation(
        Filter: {
            DisplayOption: $DisplayOption
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            Regions: $Regions
            Countries: $Countries
            CompanyIds: $CompanyIds
            UserId: $UserId
            OrganisationId: $OrganisationId
            Customer: $Customer
            IsCalendarView: $IsCalendarView
            ConversionCurrency: $ConversionCurrency
            OrganisationCurrencies: $OrganisationCurrencies
            CustomerId: $CustomerId
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TotalAmountOwing
    }
}

query GET_NOTIFICATION_SUCCESS_REPORT_FOR_ORGANISATION(
    $DateMin: String
    $DateMax: String
    $IsMonthlyView: Boolean
    $DisplayOption: String
    $IsCreatedDateView: Boolean
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $Countries: [String]
    $Postcodes: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $UserId: ID
    $OrganisationId: ID
    $Customer: String
    $ConversionCurrency: Float
    $OrganisationCurrencies: [OrganisationCurrencyInput]
    $CustomerId: ID
    $ViewAssociatedCustomers: Boolean = false
) {
    GetNotificationSuccessReportForOrganisation(
        Filter: {
            DateMin: $DateMin
            DateMax: $DateMax
            IsMonthlyView: $IsMonthlyView
            DisplayOption: $DisplayOption
            IsCreatedDateView: $IsCreatedDateView
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            Countries: $Countries
            Postcodes: $Postcodes
            Regions: $Regions
            CompanyIds: $CompanyIds
            UserId: $UserId
            OrganisationId: $OrganisationId
            Customer: $Customer
            ConversionCurrency: $ConversionCurrency
            OrganisationCurrencies: $OrganisationCurrencies
            CustomerId: $CustomerId
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        NotificationSuccesses {
            StateName
            OriginalAmount
            AmountPaid
            PercentageRecovered
        }
        InvoiceTotal
        AmountPaidTotal
        PercentageRecoveredTotal
    }
}

query GET_COMPANY_SALES_REPORT_FOR_ORGANISATION(
    $DateMin: String
    $DateMax: String
    $IsMonthlyView: Boolean
    $DisplayOption: String
    $IsCreatedDateView: Boolean
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $Countries: [String]
    $Postcodes: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $UserId: ID
    $OrganisationId: ID
    $Customer: String
    $IsCalendarView: Boolean
    $ConversionCurrency: Float
    $OrganisationCurrencies: [OrganisationCurrencyInput]
    $CustomerId: ID
    $ViewAssociatedCustomers: Boolean = false
) {
    GetCompanySalesReportForOrganisation(
        Filter: {
            DateMin: $DateMin
            DateMax: $DateMax
            IsMonthlyView: $IsMonthlyView
            DisplayOption: $DisplayOption
            IsCreatedDateView: $IsCreatedDateView
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            Countries: $Countries
            Postcodes: $Postcodes
            Regions: $Regions
            CompanyIds: $CompanyIds
            UserId: $UserId
            OrganisationId: $OrganisationId
            Customer: $Customer
            IsCalendarView: $IsCalendarView
            ConversionCurrency: $ConversionCurrency
            OrganisationCurrencies: $OrganisationCurrencies
            CustomerId: $CustomerId
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        Sales {
            AmountOwing
            AmountPaid
            DisplayPeriod
            Year
        }
    }
}

query GET_COMPANY_INVOICING_SETTLEMENT_REPORT_FOR_ORGANISATION(
    $DateMin: String
    $DateMax: String
    $IsMonthlyView: Boolean
    $DisplayOption: String
    $IsCreatedDateView: Boolean
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $Countries: [String]
    $Postcodes: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $UserId: ID
    $OrganisationId: ID
    $Customer: String
    $ConversionCurrency: Float
    $OrganisationCurrencies: [OrganisationCurrencyInput]
    $CustomerId: ID
    $ViewAssociatedCustomers: Boolean = false
) {
    GetCompanyInvoicingSettlementReportForOrganisation(
        Filter: {
            DateMin: $DateMin
            DateMax: $DateMax
            IsMonthlyView: $IsMonthlyView
            DisplayOption: $DisplayOption
            IsCreatedDateView: $IsCreatedDateView
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            Countries: $Countries
            Postcodes: $Postcodes
            Regions: $Regions
            CompanyIds: $CompanyIds
            UserId: $UserId
            OrganisationId: $OrganisationId
            Customer: $Customer
            ConversionCurrency: $ConversionCurrency
            OrganisationCurrencies: $OrganisationCurrencies
            CustomerId: $CustomerId
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        InvoicingSettlements {
            OriginalAmount
            InvoicingSettlementType
            DisplayPeriod
            Year
        }
    }
}

query GET_NOTIFICATIONS_REPORT_FOR_ORGANISATION(
    $DateMin: String
    $DateMax: String
    $IsMonthlyView: Boolean
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $Countries: [String]
    $Postcodes: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $UserId: ID
    $OrganisationId: ID
    $Customer: String
    $ConversionCurrency: Float
    $OrganisationCurrencies: [OrganisationCurrencyInput]
    $CustomerId: ID
    $ViewAssociatedCustomers: Boolean = false
) {
    GetNotificationReportForOrganisation(
        Filter: {
            DateMin: $DateMin
            DateMax: $DateMax
            IsMonthlyView: $IsMonthlyView
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            Countries: $Countries
            Postcodes: $Postcodes
            Regions: $Regions
            CompanyIds: $CompanyIds
            UserId: $UserId
            OrganisationId: $OrganisationId
            Customer: $Customer
            ConversionCurrency: $ConversionCurrency
            OrganisationCurrencies: $OrganisationCurrencies
            CustomerId: $CustomerId
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        Notifications {
            CountType
            Count
            DisplayPeriod
            Year
        }
    }
}

query GET_CUSTOMER_CURRENT_ATB_REPORT_FOR_ORGANISATION(
    $IsCreatedDateView: Boolean
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $Countries: [String]
    $Postcodes: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $UserId: ID
    $OrganisationId: ID
    $Customer: String
    $IsCalendarView: Boolean
    $IncludeManualItemsATB: Boolean
    $IncludeRebatesATB: Boolean
    $ConversionCurrency: Float
    $OrganisationCurrencies: [OrganisationCurrencyInput]
    $CustomerId: ID
    $ViewAssociatedCustomers: Boolean = false
) {
    GetCustomerCurrentATBReportForOrganisation(
        Filter: {
            IsCreatedDateView: $IsCreatedDateView
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            Countries: $Countries
            Postcodes: $Postcodes
            Regions: $Regions
            CompanyIds: $CompanyIds
            UserId: $UserId
            OrganisationId: $OrganisationId
            Customer: $Customer
            IsCalendarView: $IsCalendarView
            IncludeManualItemsATB: $IncludeManualItemsATB
            IncludeRebatesATB: $IncludeRebatesATB
            ConversionCurrency: $ConversionCurrency
            OrganisationCurrencies: $OrganisationCurrencies
            CustomerId: $CustomerId
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        Current
        CurrentPercentage
        Period1
        Period1Percentage
        Period2
        Period2Percentage
        Period3Plus
        Period3PlusPercentage
        NotDue
        NotDuePercentage
    }
}

query GET_INVOICES_FOR_ORGANISATION_AUTOCOMPLETE_FILTER(
    $InvoiceState: String
    $InvoiceNumber: String
    $Customer: String
    $CustomerCode: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $DueDateMin: String
    $DueDateMax: String
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $InvoiceIds: [ID]
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $IsBlocked: Boolean
    $Countries: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $OrganisationCurrencies: [OrganisationCurrencyInput]
    $ConversionCurrency: Float
    $IsBlocked: Boolean
    $CustomerCountry: String
    $CustomerState: String
    $UserId: ID
    $OrganisationId: ID
    $FetchOrganisationData: Boolean = false
    $CustomerFirstLetter: [String]
    $CustomerId: ID
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetInvoicesForOrganisation(
        FetchOrganisationData: $FetchOrganisationData
        Filter: {
            InvoiceState: $InvoiceState
            InvoiceNumber: $InvoiceNumber
            Customer: $Customer
            CustomerCode: $CustomerCode
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            DueDateMin: $DueDateMin
            DueDateMax: $DueDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            InvoiceIds: $InvoiceIds
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            OrganisationCurrencies: $OrganisationCurrencies
            ConversionCurrency: $ConversionCurrency
            IsBlocked: $IsBlocked
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            UserId: $UserId
            OrganisationId: $OrganisationId
            CustomerFirstLetter: $CustomerFirstLetter
            CustomerId: $CustomerId
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        Invoices {
            Id
            CompanyId
            Number
            CreatedDate
            LocalCreatedDate
            DueDate
            LocalDueDate
            OriginalAmount
            AmountOwing
            State
            SettledDate
            LocalSettledDate
            Customer {
                Id
                CustomerCode @skip(if: $IsCloudImportType)
                CompanyName
                Contacts {
                    ...ContactFragment
                }
                DisplayName
                CustomFields {
                    ...CustomFieldFragment
                }
                IsVip
                NewInvoiceSendMode
                CurrentTask {
                    Id
                    Automation
                    ActionDate
                    Type
                    Workflow {
                        StateName
                        WorkflowName
                    }
                    Ticket {
                        TicketOption {
                            Reason
                            CaptureMessage
                        }
                        TicketNumber
                    }
                    State
                }
            }
            ConversationLine {
                ...ConversationLineCommentFragment
            }
            CustomFields {
                ...CustomFieldFragment
            }
            Company {
                Name
            }
            CurrentTask {
                Id
                Automation
                ActionDate
                Type
                Ticket {
                    TicketOption {
                        Reason
                        CaptureMessage
                        NonBlocking
                    }
                    TicketNumber
                }
                State
            }
            IsBlocked
        }
    }
}

query GET_INVOICES_FOR_ORGANISATION(
    $InvoiceState: String
    $InvoiceNumber: String
    $Customer: String
    $CustomerId: ID
    $CustomerCode: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $DueDateMin: String
    $DueDateMax: String
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $InvoiceIds: [ID]
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $IsCloudImportType: Boolean = false
    $IsBlocked: Boolean
    $Countries: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $OrganisationCurrencies: [OrganisationCurrencyInput]
    $ConversionCurrency: Float
    $IsBlocked: Boolean
    $CustomerCountry: String
    $CustomerState: String
    $UserId: ID
    $OrganisationId: ID
    $FetchOrganisationData: Boolean = false
    $CustomerFirstLetter: [String]
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
    $IsVip: Boolean
    $VipUntilMax: String
    $VipUntilMin: String
) {
    GetInvoicesForOrganisation(
        FetchOrganisationData: $FetchOrganisationData
        Filter: {
            InvoiceState: $InvoiceState
            InvoiceNumber: $InvoiceNumber
            Customer: $Customer
            CustomerId: $CustomerId
            CustomerIds: $CustomerIds
            CustomerCode: $CustomerCode
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            DueDateMin: $DueDateMin
            DueDateMax: $DueDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            InvoiceIds: $InvoiceIds
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            OrganisationCurrencies: $OrganisationCurrencies
            ConversionCurrency: $ConversionCurrency
            IsBlocked: $IsBlocked
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            UserId: $UserId
            OrganisationId: $OrganisationId
            CustomerFirstLetter: $CustomerFirstLetter
            ViewAssociatedCustomers: $ViewAssociatedCustomers
            IsVip: $IsVip
            VipUntilMax: $VipUntilMax
            VipUntilMin: $VipUntilMin
        }
    ) {
        Invoices {
            Id
            CompanyId
            Number
            CreatedDate
            LocalCreatedDate
            DueDate
            LocalDueDate
            OriginalAmount
            AmountOwing
            State
            SettledDate
            LocalSettledDate
            AgedTrialBalanceFromCreate {
                ...AgedTrialBalanceFromCreateFragment
            }
            AgedTrialBalanceFromDue {
                ...AgedTrialBalanceFromDueFragment
            }
            Customer {
                Id
                CustomerCode @skip(if: $IsCloudImportType)
                CompanyName
                Contacts {
                    ...ContactFragment
                }
                DisplayName
                CustomFields {
                    ...CustomFieldFragment
                }
                AgedTrialBalance {
	                TotalOverdue
                }
                IsVip
                IsVipExpiryDate
                NewInvoiceSendMode
                CurrentTask {
                    Id
                    Automation
                    ActionDate
                    Type
                    Workflow {
                        StateName
                        WorkflowName
                    }
                    Ticket {
                        TicketOption {
                            Reason
                            CaptureMessage
                        }
                        TicketNumber
                    }
                    State
                }
            }
            ConversationLine {
                ...ConversationLineCommentFragment
            }
            CustomFields {
                ...CustomFieldFragment
            }
            Company {
                Name
            }
            LastCommunication {
                StateName
                SentDateTime
                DeliveryDetails {
                    ...DeliveryDetailFragment
                }
                WorkflowName
            }
            CurrentTask {
                Id
                Automation
                ActionDate
                Type
                Workflow {
                    StateName
                    WorkflowName
                }
                Ticket {
                    TicketOption {
                        Reason
                        CaptureMessage
                        NonBlocking
                    }
                    TicketNumber
                }
                State
            }
            IsBlocked
        }
    }
}

query GET_CREDITS_FOR_ORGANISATION(
	$CompanyId: ID
	$CreditNumber: String
	$CustomerId: ID
	$Customer: String
	$CustomerCode: String
	$CreatedDateMin: String
	$CreatedDateMax: String
	$AvailableDateMin: String
	$AvailableDateMax: String
	$AmountType: String
	$AmountValue: String
	$AmountOperator: String
	$SortField: String
	$Ascending: Boolean
	$Skip: Int
	$PageSize: Int
	$CreditState: String
	$CreditIds: [ID]
	$CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
	$CustomFieldSort: String
	$ExcludeCredits: Boolean
	$Countries: [String]
	$Regions: [String]
	$CompanyIds: [ID]
	$OrganisationCurrencies: [OrganisationCurrencyInput]
	$ConversionCurrency: Float
    $IsCloudImportType: Boolean = false
    $UserId: ID
    $OrganisationId: ID
    $Type: String
    $CreatedType: String
    $Recurring: Boolean
    $MultipleCustomer: Boolean
    $FetchOrganisationData: Boolean = false
    $CustomerFirstLetter: [String]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetCreditsForOrganisation(
        FetchOrganisationData: $FetchOrganisationData
        Filter: {
            CompanyId: $CompanyId
            CreditNumber: $CreditNumber
            CustomerId: $CustomerId
            Customer: $Customer
            CustomerCode: $CustomerCode
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            AvailableDateMin: $AvailableDateMin
            AvailableDateMax: $AvailableDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CreditState: $CreditState
            CreditIds: $CreditIds
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            ExcludeCredits: $ExcludeCredits
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            OrganisationCurrencies: $OrganisationCurrencies
            ConversionCurrency: $ConversionCurrency
            UserId: $UserId
            OrganisationId: $OrganisationId
            Type: $Type
            CreatedType: $CreatedType
            Recurring: $Recurring
            MultipleCustomer: $MultipleCustomer
            CustomerFirstLetter: $CustomerFirstLetter
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        Credits {
            Id
            CompanyId
            CreditCode
            Number
            CreatedDate
            LocalCreatedDate
            AvailableDate
            LocalAvailableDate
            OriginalAmount
            AmountAvailable
            State
            ClosedDate
            Customer {
                Id
                CustomerCode @skip(if: $IsCloudImportType)
                CompanyName
                DisplayName
                Contacts {
                    ...ContactFragment
                }
                CustomFields {
                    ...CustomFieldFragment
                }
            }
            Uri
            CustomFields {
                ...CustomFieldFragment
            }
            Attachments {
                ...AttachmentFragment
            }
            Type
            CreatedType
            Percentage
            Description
            IsRecurring
            Company {
                Name
            }
            MultipleCustomer
        }
    }
}

query GET_CREDITS_FOR_ORGANISATION_AUTOCOMPLETE_FILTER(
	$CompanyId: ID
	$CreditNumber: String
	$CustomerId: ID
	$Customer: String
	$CustomerCode: String
	$CreatedDateMin: String
	$CreatedDateMax: String
	$AvailableDateMin: String
	$AvailableDateMax: String
	$AmountType: String
	$AmountValue: String
	$AmountOperator: String
	$SortField: String
	$Ascending: Boolean
	$Skip: Int
	$PageSize: Int
	$CreditState: String
	$CreditIds: [ID]
	$CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
	$CustomFieldSort: String
	$ExcludeCredits: Boolean
	$Countries: [String]
	$Regions: [String]
	$CompanyIds: [ID]
	$OrganisationCurrencies: [OrganisationCurrencyInput]
	$ConversionCurrency: Float
    $IsCloudImportType: Boolean = false
    $UserId: ID
    $OrganisationId: ID
    $Type: String
    $CreatedType: String
    $Recurring: Boolean
    $FetchOrganisationData: Boolean = false
    $CustomerFirstLetter: [String]
) {
    GetCreditsForOrganisation(
        FetchOrganisationData: $FetchOrganisationData
        Filter: {
            CompanyId: $CompanyId
            CreditNumber: $CreditNumber
            CustomerId: $CustomerId
            Customer: $Customer
            CustomerCode: $CustomerCode
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            AvailableDateMin: $AvailableDateMin
            AvailableDateMax: $AvailableDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CreditState: $CreditState
            CreditIds: $CreditIds
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            ExcludeCredits: $ExcludeCredits
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            OrganisationCurrencies: $OrganisationCurrencies
            ConversionCurrency: $ConversionCurrency
            UserId: $UserId
            OrganisationId: $OrganisationId
            Type: $Type
            CreatedType: $CreatedType
            Recurring: $Recurring
            CustomerFirstLetter: $CustomerFirstLetter
        }
    ) {
        Credits {
            Id
            CompanyId
            CreditCode
            Number
            CreatedDate
            LocalCreatedDate
            AvailableDate
            LocalAvailableDate
            OriginalAmount
            AmountAvailable
            State
            ClosedDate
            Customer {
                Id
                CustomerCode @skip(if: $IsCloudImportType)
                CompanyName
                DisplayName
                Contacts {
                    ...ContactFragment
                }
                CustomFields {
                    ...CustomFieldFragment
                }
            }
            Uri
            CustomFields {
                ...CustomFieldFragment
            }
            Attachments {
                ...AttachmentFragment
            }
            Type
            CreatedType
            Percentage
            Description
            IsRecurring
            Company {
                Name
            }
            MultipleCustomer
        }
    }
}

query GET_CUSTOMERS_FOR_ORGANISATION(
    $Customer: String
    $InclusiveContact: Boolean
    $Contact: Int
    $ATBType: Int
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $IsCloudImportType: Boolean = false
    $Countries: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $OrganisationCurrencies: [OrganisationCurrencyInput]
    $ConversionCurrency: Float
    $IsVip: Boolean
    $CustomerCountry: String
    $CustomerState: String
    $UserId: ID
    $OrganisationId: ID 
    $FetchOrganisationData: Boolean = false
    $CustomerFirstLetter: [String]
    $StateOfCustomers: String
) {
    GetCustomersForOrganisation(
        FetchOrganisationData: $FetchOrganisationData
        Filter: {
            Customer: $Customer
            InclusiveContact: $InclusiveContact
            Contact: $Contact
            ATBType: $ATBType
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            OrganisationCurrencies: $OrganisationCurrencies
            ConversionCurrency: $ConversionCurrency
            IsVip: $IsVip
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            UserId: $UserId
            OrganisationId: $OrganisationId
            CustomerFirstLetter: $CustomerFirstLetter
            StateOfCustomers: $StateOfCustomers
        }
    ) {
        Customers {
            ...CustomerFragment
            ConversationLine {
                ...ConversationLineCommentFragment
            }
            Company {
                Name
            }
            LastCommunication {
                StateName
                SentDateTime
                DeliveryDetails {
                    ...DeliveryDetailFragment
                }
                WorkflowName                
            }
            CurrentTask {
                Id
                Automation
                ActionDate
                Type
                Workflow {
                    StateName
                    WorkflowName
                }
                Ticket {
                    TicketOption {
                        Reason
                        CaptureMessage
                    }
                    TicketNumber
                }
                State
            }
        }
    }
}

query GET_TASK_COUNT_BY_STATE_NAME_FOR_ORGANISATION(
    $DisplayName: String
    $CustomerCode: String
    $InvoiceNumber: String
    $AmountValue: Float
    $AmountOperator: String
    $ActionDateMin: AWSDateTime
    $ActionDateMax: AWSDateTime
    $CreatedDateMin: AWSDateTime
    $CreatedDateMax: AWSDateTime
    $Type: Int
    $CustomerCountry: String
    $CustomerState: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $WorkflowFilters: [WorkflowFilterInput]
    $Countries: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $UserId: ID
    $OrganisationId: ID
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTaskCountByStateNameForOrganisation(
        Filter: {
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            InvoiceNumber: $InvoiceNumber
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            ActionDateMin: $ActionDateMin
            ActionDateMax: $ActionDateMax
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            Type: $Type
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            WorkflowFilters: $WorkflowFilters
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            UserId: $UserId
            OrganisationId: $OrganisationId
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TaskCountStateNames {
            Count
            StateName
        }
    }
}

query GET_TASK_COUNT_BY_USER_FOR_ORGANISATION(
    $DisplayName: String
    $CustomerCode: String
    $InvoiceNumber: String
    $AmountValue: Float
    $AmountOperator: String
    $ActionDateMin: AWSDateTime
    $ActionDateMax: AWSDateTime
    $CreatedDateMin: AWSDateTime
    $CreatedDateMax: AWSDateTime
    $Type: Int
    $CustomerCountry: String
    $CustomerState: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $WorkflowFilters: [WorkflowFilterInput]
    $Status: Int
    $Contact: Int
    $Countries: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $UserId: ID
    $OrganisationId: ID
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTaskCountByUserForOrganisation(
        Filter: { 
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            InvoiceNumber: $InvoiceNumber
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            ActionDateMin: $ActionDateMin
            ActionDateMax: $ActionDateMax
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            Type: $Type
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            WorkflowFilters: $WorkflowFilters
            Status: $Status
            Contact: $Contact
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            UserId: $UserId
            OrganisationId: $OrganisationId
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TaskUserCounts {
            Count
	        User {
                UserId
                GivenName
                FamilyName
                Email
                CreatedDateTime
            }
	        AssignedEmailAddress
        }
    }
}

query GET_TASK_COUNT_BY_USER_TYPE_FOR_ORGANISATION(
    $DisplayName: String
    $CustomerCode: String
    $InvoiceNumber: String
    $AmountValue: Float
    $AmountOperator: String
    $ActionDateMin: AWSDateTime
    $ActionDateMax: AWSDateTime
    $CreatedDateMin: AWSDateTime
    $CreatedDateMax: AWSDateTime
    $Type: Int
    $CustomerCountry: String
    $CustomerState: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $WorkflowFilters: [WorkflowFilterInput]
    $Status: Int
    $Contact: Int
    $Countries: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $UserId: ID
    $OrganisationId: ID
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTaskCountByUserTypeForOrganisation(
        Filter: { 
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            InvoiceNumber: $InvoiceNumber
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            ActionDateMin: $ActionDateMin
            ActionDateMax: $ActionDateMax
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            Type: $Type
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            WorkflowFilters: $WorkflowFilters
            Status: $Status
            Contact: $Contact
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            UserId: $UserId
            OrganisationId: $OrganisationId
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TaskUserTypeCounts {
            Count
	        UserType
        }
    }
}

query GET_TICKET_COUNT_BY_STATUS_FOR_ORGANISATION(
    $DisplayName: String
    $CustomerCode: String
    $CustomerCountry: String
    $CustomerState: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $ClosedDateMin: String
    $ClosedDateMax: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $TicketOptionReasons: [String]
    $Status: Int
    $Countries: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $UserId: ID
    $OrganisationId: ID
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTicketCountByStatusForOrganisation(
        Filter: {
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            ClosedDateMin: $ClosedDateMin
            ClosedDateMax: $ClosedDateMax
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            TicketOptionReasons: $TicketOptionReasons
            Status: $Status
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            UserId: $UserId
            OrganisationId: $OrganisationId
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        OpenSum
    }
}

query GET_TICKET_COUNT_BY_GROUPING_FOR_ORGANISATION(
    $DisplayName: String
    $CustomerCode: String
    $CustomerCountry: String
    $CustomerState: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $ClosedDateMin: String
    $ClosedDateMax: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $TicketOptionReasons: [String]
    $Countries: [String]
    $Postcodes: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $Status: Int = -1
    $UserId: ID
    $OrganisationId: ID
    $CustomerIds: [ID]
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTicketCountByGroupingForOrganisation(
        Filter: {
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            ClosedDateMin: $ClosedDateMin
            ClosedDateMax: $ClosedDateMax
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            TicketOptionReasons: $TicketOptionReasons
            Postcodes: $Postcodes
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            Status: $Status
            UserId: $UserId
            OrganisationId: $OrganisationId
            CustomerIds: $CustomerIds
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TicketCounts {
            OpenSum
            ClosedSum
            State
            Reason
        }
    }
}

query GET_TICKET_COUNT_BY_USER_FOR_ORGANISATION(
    $DisplayName: String
    $CustomerCode: String
    $CustomerCountry: String
    $CustomerState: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $ClosedDateMin: String
    $ClosedDateMax: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $TicketOptionReasons: [String]
    $Countries: [String]
    $Postcodes: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $Status: Int = -1
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $UserId: ID
    $OrganisationId: ID
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTicketCountByUserForOrganisation(
        Filter: {
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            ClosedDateMin: $ClosedDateMin
            ClosedDateMax: $ClosedDateMax
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            TicketOptionReasons: $TicketOptionReasons
            Postcodes: $Postcodes
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            Status: $Status
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            UserId: $UserId
            OrganisationId: $OrganisationId
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TicketUserCounts {
            OpenSum
            ClosedSum
            User {
                UserId
                GivenName
                FamilyName
                Email
                CreatedDateTime
            }
	        AssignedEmailAddress
        }
    }
}

query GET_TICKET_COUNT_BY_USER_TYPE_FOR_ORGANISATION(
    $DisplayName: String
    $CustomerCode: String
    $CustomerCountry: String
    $CustomerState: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $ClosedDateMin: String
    $ClosedDateMax: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $TicketOptionReasons: [String]
    $Countries: [String]
    $Postcodes: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $Status: Int = -1
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $UserId: ID
    $OrganisationId: ID
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTicketCountByUserTypeForOrganisation(
        Filter: {
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            ClosedDateMin: $ClosedDateMin
            ClosedDateMax: $ClosedDateMax
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            TicketOptionReasons: $TicketOptionReasons
            Postcodes: $Postcodes
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            Status: $Status
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            UserId: $UserId
            OrganisationId: $OrganisationId
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TicketUserTypeCounts {
            OpenSum
            ClosedSum
            UserType
        }
    }
}

query GET_USERS_FOR_ORGANISATION(
    $CompanyIds: [ID]
    $Name: String
    $Email: String
    $RoleIds: [ID]
) {
    GetUsersForOrganisation(
        Filter: {
            CompanyIds: $CompanyIds
            Name: $Name
            Email: $Email
            RoleIds: $RoleIds
        }
    ) {
        OrganisationUsers {
            User {
                UserId
                GivenName
                FamilyName
                Email
                CreatedDateTime
            }
            IsAdminRole
            CompanyNames
        }
    }
}

query GET_USERS_FOR_ORGANISATION_AUTOCOMPLETE_FILTER(
    $CompanyIds: [ID]
    $Name: String
    $Email: String
    $RoleIds: [ID]
) {
    GetUsersForOrganisation(
        Filter: {
            CompanyIds: $CompanyIds
            Name: $Name
            Email: $Email
            RoleIds: $RoleIds
        }
    ) {
        OrganisationUsers {
            User {
                UserId
                GivenName
                FamilyName
                Email
                CreatedDateTime
            }
            IsAdminRole
            CompanyNames
        }
    }
}

query GET_USER_DETAILS_FOR_ORGANISATION($UserId: ID) {
    GetUserDetailsForOrganisation(UserId: $UserId) {
        User {
            UserId
            GivenName
            FamilyName
            Email
        }
        CompanyRoles {
            CompanyName
            RoleName
        }
    }
}

query GET_INVOICE_COUNT_FOR_COMPANY(
    $CompanyId: ID
    $InvoiceState: String
    $InvoiceNumber: String
    $Customer: String
    $CustomerCode: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $DueDateMin: String
    $DueDateMax: String
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $InvoiceIds: [ID]
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $IsBlocked: Boolean
    $CustomerId: ID
    $ViewAssociatedCustomers: Boolean = false
) {
    GetInvoiceCountForCompany(
        Filter: {
            CompanyId: $CompanyId
            InvoiceState: $InvoiceState
            InvoiceNumber: $InvoiceNumber
            Customer: $Customer
            CustomerCode: $CustomerCode
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            DueDateMin: $DueDateMin
            DueDateMax: $DueDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            InvoiceIds: $InvoiceIds
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            IsBlocked: $IsBlocked
            CustomerId: $CustomerId
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        InvoiceCount
    }
}

query GET_INVOICE_COUNT_FOR_ORGANISATION(
    $InvoiceState: String
    $InvoiceNumber: String
    $Customer: String
    $CustomerCode: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $DueDateMin: String
    $DueDateMax: String
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $InvoiceIds: [ID]
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $IsBlocked: Boolean
    $Countries: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $UserId: ID
    $OrganisationId: ID
    $CustomerId: ID
    $ViewAssociatedCustomers: Boolean = false
) {
    GetInvoiceCountForOrganisation(
        Filter: {
            InvoiceState: $InvoiceState
            InvoiceNumber: $InvoiceNumber
            Customer: $Customer
            CustomerCode: $CustomerCode
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            DueDateMin: $DueDateMin
            DueDateMax: $DueDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            InvoiceIds: $InvoiceIds
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            IsBlocked: $IsBlocked
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            UserId: $UserId
            OrganisationId: $OrganisationId
            CustomerId: $CustomerId
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        InvoiceCount
    }
}

query GET_PAYMENT_PLAN_COMMUNICATION_DETAIL(
    $CommunicationId: ID!
    $AllInvoices: Boolean
    $IsPublic: Boolean = true
) {
    GetPaymentPlanCommunicationDetail(
        Filter: { 
            CommunicationId: $CommunicationId
            AllInvoices: $AllInvoices 
        }
    ) {
        Customer {
            Id
            CustomerCode
            DisplayName
            Contacts {
                Email
            }
            CustomFields {
                ...CustomFieldFragment
            }
        }
        Invoices {
            Id
            CompanyId
            Customer
            {
                Id
                CustomerCode
                DisplayName
                # CompanyName
            }
            InvoiceCode
            Number
            CreatedDate
            LocalCreatedDate
            DueDate
            LocalDueDate
            AmountOwing
            Tickets {
                Id
                TicketNumber
                TicketOption {
                    Id
                    Type
                    Reason
                    NonBlocking
                }
            }
            CustomFields {
                Name
                Value
            }
            Attachments {
                ...AttachmentFragment
            }
            ResourceAllocations {
                PaymentResource {
                    Result
                    LocalPaidDate
                    BankReceiptNumber
                }
            }
        }
        Company {
            CompanyId
            Name
            Email
            LogoPath
            AddressLine1
            AddressLine2
            Suburb
            State
            Postcode
            PhoneNumber
            PaymentOptions {
                ...PaymentOptionsFragment
            }
            PrimaryColorTheme
            CustomFieldsConfigure {
                ...CompanyCustomFieldConfigureFragment
            }
            LanguagePackage {
                ...LanguagePackageFragment
            }
            Timezone
            CompanyPaymentPlan {
                IsEnabled
                TermsAndConditions
                TotalSchedules
                Frequency
            }
            NotificationCustomization {
                ...CompanyNotificationCustomizationFragment
            }
            DefaultPaymentPlanFee
            DisableCustomerTickets
            CustomerTitleLabel
        }
        PaymentPlanSchedules {
            Id
            PaymentPlanId
            Number
            State
            TotalAmount
            AmountRemaining
            LocalDueDateTime
            LocalClosedDateTime
            CompanyId
        }
        PaymentPlans {
            Id
            CompanyId
            Number
            FeeRemaining
        }
    }
}

query GET_PAYMENT_PLANS_FOR_COMPANY(
    $Status: Int
    $CreatedDateMin: String
    $CreatedDateMax: String
    $SortField: String
    $Ascending: Boolean
    $PaymentPlanState: String
    $Skip: Int
    $PageSize: Int
    $IsCloudImportType: Boolean = false
    $PaymentPlanIds: [ID]
    $ExcludePaymentPlans: Boolean = false
    $Customer: String
    $CustomerCode: String
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetPaymentPlansForCompany(
        Filter: {
            Status: $Status
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            SortField: $SortField
            Ascending: $Ascending
            PaymentPlanState: $PaymentPlanState
            Skip: $Skip
            PageSize: $PageSize
            PaymentPlanIds: $PaymentPlanIds
            ExcludePaymentPlans: $ExcludePaymentPlans
            Customer: $Customer
            CustomerCode: $CustomerCode
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        PaymentPlans {
            Id
            Number
            TotalAmount
            AmountRemaining
            RequestedDateTime
            LocalRequestedDateTime
            ApprovedDateTime
            LocalApprovedDateTime
            ClosedDateTime
            LocalClosedDateTime
            RejectedDateTime
            LocalRejectedDateTime
            Customer {
                Id
                CompanyId
                CustomerCode @skip(if: $IsCloudImportType)
                CompanyName
                DisplayName
                Contacts {
                    ...ContactFragment
                }
                ConversationLine {
                    ...ConversationLineCommentFragment
                }
            }
            CompanyId
            InvoiceIds
            State
            TotalSchedules
            Frequency
            PaymentPlanSchedules {
                Id
                PaymentPlanId
                AmountRemaining
                TotalAmount
                Number
                LocalDueDateTime
                State
            }
            ConversationLine {
                ...ConversationLineCommentFragment
            }
            Uri
        }
    }
}

query GET_PAYMENT_PLAN_DETAILS_FOR_COMPANY(
    $PaymentPlanId: ID
    $IsCloudImportType: Boolean = false
) {
    GetPaymentPlanDetailsForCompany(PaymentPlanId: $PaymentPlanId) {
        Id
        Number
        TotalAmount
        AmountRemaining
        RequestedDateTime
        LocalRequestedDateTime
        ApprovedDateTime
        LocalApprovedDateTime
        ClosedDateTime
        LocalClosedDateTime
        RejectedDateTime
        LocalRejectedDateTime
        ActionUser {
            UserId
            GivenName
            FamilyName
        }
        Customer {
            ...CustomerFragment
            ConversationLine {
                ...ConversationLineCommentFragment
            }
        }
        CompanyId
        InvoiceIds
        State
        TotalSchedules
        Frequency
        PaymentPlanSchedules {
            Id
            PaymentPlanId
            Number
            State
            TotalAmount
            AmountRemaining
            LocalDueDateTime
            DueDateTime
            LocalClosedDateTime
        }
        ConversationLine {
            ...ConversationLineCommentFragment
        }
        Uri
        ClosedComment
    }
}

query CHECK_PAYMENT_PLANS_ACTION_STATE(
    $Status: Int
    $CreatedDateMin: String
    $CreatedDateMax: String
    $SortField: String
    $Ascending: Boolean
    $PaymentPlanState: String
    $Skip: Int
    $PageSize: Int
    $Customer: String
    $CustomerCode: String
    $PaymentPlanIds: [ID]
    $ExcludePaymentPlans: Boolean
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    PaymentPlansActionState(
        Filter: {
            Status: $Status
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            SortField: $SortField
            Ascending: $Ascending
            PaymentPlanState: $PaymentPlanState
            Skip: $Skip
            PageSize: $PageSize
            Customer: $Customer
            CustomerCode: $CustomerCode
            PaymentPlanIds: $PaymentPlanIds
            ExcludePaymentPlans: $ExcludePaymentPlans
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        ActionEnabled
    }
}

query GET_HISTORY_DELIVERY_REPORT(
    $CompanyIds: [ID]
    $BatchId: ID
    $CompanyId: ID
    $DeliveryStatus: Int
    $DeliveryType: Int
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
) {
    GetDeliveryHistoryReportForCompany(
        Filter: {
            CompanyIds: $CompanyIds
            BatchId: $BatchId
            CompanyId: $CompanyId
            DeliveryStatus: $DeliveryStatus
            DeliveryType: $DeliveryType
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
        }
    ) {
        TaskBatchGroups {
            CustomerCode
            CompanyName
            CommunicationId
            StateName
            State
            DeliveryDetails {
                ...DeliveryDetailsFragment
            }
        }
    }
}

query GET_MANUAL_COMMUNICATION_TEMPLATE_OPTIONS {
    GetManualCommunicationTemplateOptions {
        Templates {
            TemplateName
            FolderLocation
            Files {
                Name
                Type
            }
            SentToVip
        }
    }
}

query GET_COMMUNICATION_RESOURCE_RESPONSE_DETAILS(
    $ConversationLineId: ID
    $IsPublic: Boolean = true
) {
    GetCommunicationResourceResponseDetails(ConversationLineId: $ConversationLineId) {
        Id
        CompanyId
        Content 
        PrimaryResource {
            Uri
        }
        Company {
            ...CompanyPublicViewFragment
        }
    }
}

query GET_REMITTANCE_ADVICE_DETAILS(
    $RemittanceAdviceId: ID
    $IsCloudImportType: Boolean = false
) {
    GetRemittanceAdviceDetailsForCompany(RemittanceAdviceId: $RemittanceAdviceId) {
        Id
        Amount
        AllocatedAmount
        Status
        ReceivedDate
        LocalReceivedDate
        PaidDate
        LocalPaidDate
        MultipleCustomer
        Customer {
            ...CustomerFragment
        }
        RemittanceAdviceInvoices {
            ...RemittanceAdviceInvoicesFragment
        }
        RemittanceAdviceCredits {
            ...RemittanceAdviceCreditsFragment
        }
        RemittanceAdviceRebates {
            Rebate {
                ...CreditFragment
            }
            AmountToAllocate
        }
        Attachments {
            ...AttachmentFragment
        }
        PaymentResource {
            Id
        }                    
        Uri
    }
}

query GET_TASK_VIEWER_DETAIL_FOR_USER(
    $DisplayName: String
    $CustomerCode: String
    $InvoiceNumber: String
    $InvoiceDueDateMin: AWSDateTime
    $InvoiceDueDateMax: AWSDateTime
    $AmountValue: Float
    $AmountOperator: String
    $ActionDateMin: AWSDateTime
    $ActionDateMax: AWSDateTime
    $CreatedDateMin: AWSDateTime
    $CreatedDateMax: AWSDateTime
    $Type: Int
    $Automation: Int
    $Contact: Int
    $Status: Int
    $TaskIds: [ID]
    $ExcludeTasks: Boolean
    $SortField: String
    $ThenSortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $WorkflowFilters: [WorkflowFilterInput]
    $CustomerCountry: String
    $CustomerState: String
    $Action: Int
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTaskViewerDetailForUser(
        Filter: {
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            InvoiceNumber: $InvoiceNumber
            InvoiceDueDateMin: $InvoiceDueDateMin
            InvoiceDueDateMax: $InvoiceDueDateMax
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            ActionDateMin: $ActionDateMin
            ActionDateMax: $ActionDateMax
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            Type: $Type
            Automation: $Automation
            Contact: $Contact
            Status: $Status
            TaskIds: $TaskIds
            ExcludeTasks: $ExcludeTasks
            SortField: $SortField
            ThenSortField: $ThenSortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            WorkflowFilters: $WorkflowFilters
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            Action: $Action
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        User {
            UserId
            GivenName
	        FamilyName
        }
    }
}

query GET_TASK_VIEWER_DETAIL_FOR_USER_ORGANISATION(
    $DisplayName: String
    $CustomerCode: String
    $InvoiceNumber: String
    $InvoiceDueDateMin: AWSDateTime
    $InvoiceDueDateMax: AWSDateTime
    $AmountValue: Float
    $AmountOperator: String
    $ActionDateMin: AWSDateTime
    $ActionDateMax: AWSDateTime
    $CreatedDateMin: AWSDateTime
    $CreatedDateMax: AWSDateTime
    $Type: Int
    $Automation: Int
    $Contact: Int
    $Status: Int
    $TaskIds: [ID]
    $ExcludeTasks: Boolean
    $SortField: String
    $ThenSortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $WorkflowFilters: [WorkflowFilterInput]
    $CustomerCountry: String
    $CustomerState: String
    $Action: Int
    $CompanyId: ID
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTaskViewerDetailForUserOrganisation(
        Filter: {
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            InvoiceNumber: $InvoiceNumber
            InvoiceDueDateMin: $InvoiceDueDateMin
            InvoiceDueDateMax: $InvoiceDueDateMax
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            ActionDateMin: $ActionDateMin
            ActionDateMax: $ActionDateMax
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            Type: $Type
            Automation: $Automation
            Contact: $Contact
            Status: $Status
            TaskIds: $TaskIds
            ExcludeTasks: $ExcludeTasks
            SortField: $SortField
            ThenSortField: $ThenSortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            WorkflowFilters: $WorkflowFilters
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            Action: $Action
            CompanyId: $CompanyId
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        User {
            UserId
            GivenName
	        FamilyName
        }
    }
}

query GET_REPORT_HISTORIES_FOR_COMPANY(
    $ReportJobId: ID
    $UserId: ID
    $CreatedDateMin: String
    $CreatedDateMax: String
    $ReportTypeFilters: [ReportTypeFilterInput]
    $Status: Int
    $Skip: Int
    $PageSize: Int
) {
    GetReportHistoriesForCompany(
        Filter: {
            ReportJobId: $ReportJobId
            UserId: $UserId
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            ReportTypeFilters: $ReportTypeFilters
            Status: $Status
            Skip: $Skip
            PageSize: $PageSize
        }
    ) {
        ReportHistories {
            ReportJobId
            User {
                UserId
                GivenName
                FamilyName
            }
            Title
            Description
            Type
            Status
            CreatedDateTime
            CompletedDateTime
            ReportAppliedFilters {
                Name
                Value
            }
        }
    }
}

query GET_REPORT_HISTORIES_FOR_ORGANISATION(
    $ReportJobId: ID
    $UserId: ID
    $CreatedDateMin: String
    $CreatedDateMax: String
    $ReportTypeFilters: [ReportTypeFilterInput]
    $CompanyIds: [ID]
    $Status: Int
    $Skip: Int
    $PageSize: Int
    $FilterByCompanyIdsOnly: Boolean
) {
    GetReportHistoriesForOrganisation(
        FilterByCompanyIdsOnly: $FilterByCompanyIdsOnly
        Filter: {
            ReportJobId: $ReportJobId
            UserId: $UserId
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            ReportTypeFilters: $ReportTypeFilters
            Status: $Status
            CompanyIds: $CompanyIds
            Skip: $Skip
            PageSize: $PageSize
        }
    ) {
        ReportHistories {
            ReportJobId
            User {
                UserId
                GivenName
                FamilyName
            }
            Title
            Description
            Type
            Status
            CreatedDateTime
            CompletedDateTime
            Company {
                CompanyId
                Name
            }
            ReportAppliedFilters {
                Name
                Value
            }
        }
    }
}

query GET_COMMUNICATION_DELIVERY_FOR_COMPANY(
    $CompanyId: ID
	$CompanyIds: [ID]
	$Automation: Int
	$CreatedDateMin: String
	$CreatedDateMax: String
	$WorkflowFilters: [WorkflowFilterInput]
    $ContactType: Int
    $DisplayName: String
    $CustomerCode: String
    $ViewAssociatedCustomers: Boolean = false
    $CustomerIds: [ID]
) {
    GetDeliveryCountsForCompany(
        Filter: {
            CompanyId: $CompanyId
            CompanyIds: $CompanyIds
            Automation: $Automation
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            WorkflowFilters: $WorkflowFilters
            ContactType: $ContactType
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            ViewAssociatedCustomers: $ViewAssociatedCustomers
            CustomerIds: $CustomerIds
        }
    ) {
        DeliveryCounts {
            StateName
            ContactType
            FailedCount
            DeliveredCount
            OpenedCount
            CancelledCount
        }
    }
}

query GET_COMMUNICATION_DELIVERY_FOR_ORGANISATION(
    $CompanyId: ID
	$CompanyIds: [ID]
	$Automation: Int
	$CreatedDateMin: String
	$CreatedDateMax: String
	$WorkflowFilters: [WorkflowFilterInput]
    $ContactType: Int
    $UserId: ID
    $OrganisationId: ID
    $DisplayName: String
    $CustomerCode: String
    $ViewAssociatedCustomers: Boolean = false
) {
    GetDeliveryCountsForOrganisation(
        Filter: {
            CompanyId: $CompanyId
            CompanyIds: $CompanyIds
            Automation: $Automation
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            WorkflowFilters: $WorkflowFilters
            ContactType: $ContactType
            UserId: $UserId
            OrganisationId: $OrganisationId
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        DeliveryCounts {
            StateName
            ContactType
            FailedCount
            DeliveredCount
            OpenedCount
            CancelledCount
        }
    }
}

query GET_REPORT_DETAILS(
    $ReportJobId: ID
) {
    GetReportHistoryDetails(ReportJobId: $ReportJobId) {
        ReportJobId
        CompanyId
        User {
            UserId
            GivenName
            FamilyName
        }
        Title
        Description
        Type
        Status
        CreatedDateTime
        CompletedDateTime
        ReportAppliedFilters {
            Name
            Value
        }
    }
}

query GET_TASK_WORKFLOWS_FOR_COMPANY($WorkflowFilters: [WorkflowFilterInput]) {
    GetTaskWorkflowsForCompany(WorkflowFilters: $WorkflowFilters) {
        WorkflowId
        WorkflowName
        StateName
    }
}

query GET_REPORT_DETAILS_FOR_ORGANISATION(
    $ReportJobId: ID
) {
    GetReportHistoryDetailsForOrganisation(ReportJobId: $ReportJobId) {
        ReportJobId
        CompanyId
        Company {
            Name
        }
        User {
            UserId
            GivenName
            FamilyName
        }
        Title
        Description
        Type
        Status
        CreatedDateTime
        CompletedDateTime
        ReportAppliedFilters {
            Name
            Value
        }
    }
}

query GET_CASFHLOW_FORECAST_FOR_COMPANY (
    $CompanyId: ID
    $PageSize: Int
    $DueDateMin: String
	$DueDateMax: String
) {
    GetCashflowForecastForCompany (
        Filter: {
            CompanyId: $CompanyId
            PageSize: $PageSize
            DueDateMin: $DueDateMin
	        DueDateMax: $DueDateMax
        }
    ) {
        CashflowForecastList {
            CashflowForecastData 
        }        
    }
}

query GET_CASFHLOW_FORECAST_FOR_ORGANISATION (
    $CompanyId: ID
    $PageSize: Int
    $DueDateMin: String
	$DueDateMax: String
    $ConversionCurrency: Float
    $OrganisationCurrencies: [OrganisationCurrencyInput]
    $CompanyIds: [ID]
) {
    GetCashflowForecastForOrganisation (
        Filter: {
            CompanyId: $CompanyId
            PageSize: $PageSize
            DueDateMin: $DueDateMin
	        DueDateMax: $DueDateMax
            ConversionCurrency: $ConversionCurrency
            OrganisationCurrencies: $OrganisationCurrencies
            CompanyIds: $CompanyIds
        }
    ) {
        CashflowForecastList {
            CashflowForecastData
        }
    }
}

query GET_REMITTANCE_ADVICE_INVOICE(
    $RemittanceAdviceId : ID
    $InvoiceState: String
    $InvoiceNumber: String
    $CustomerId: ID
    $Customer: String
    $CustomerCode: String
    $CustomerCountry: String
    $CustomerState: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $DueDateMin: String
    $DueDateMax: String
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CompanyId: ID
    $IsCloudImportType: Boolean = false
    $ShowErrorsOnly: Boolean
    $ViewRemainingAmounts: Boolean
    $FilterAllowOverpayments: Boolean  
) {
    GetRemittanceAdviceInvoicesForRemittanceAdvice (
        RemittanceAdviceId: $RemittanceAdviceId
        Filter: {
            InvoiceState: $InvoiceState
            InvoiceNumber: $InvoiceNumber
            CustomerId: $CustomerId
            Customer: $Customer
            CustomerCode: $CustomerCode
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            DueDateMin: $DueDateMin
            DueDateMax: $DueDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CompanyId: $CompanyId
            ShowErrorsOnly: $ShowErrorsOnly
            ViewRemainingAmounts: $ViewRemainingAmounts
            FilterAllowOverpayments: $FilterAllowOverpayments
        }
    ) {
        RemittanceAdviceInvoices {
            ...RemittanceAdviceInvoicesFragment
        }
    }
}

query GET_REMITTANCE_ADVICE_SALES_ORDERS(
    $RemittanceAdviceId : ID
    $InvoiceState: String
    $InvoiceNumber: String
    $CustomerId: ID
    $Customer: String
    $CustomerCode: String
    $CustomerCountry: String
    $CustomerState: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $DueDateMin: String
    $DueDateMax: String
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CompanyId: ID
    $IsCloudImportType: Boolean = false  
) {
    GetRemittanceAdviceSalesOrdersForRemittanceAdvice (
        RemittanceAdviceId: $RemittanceAdviceId
        Filter: {
            InvoiceState: $InvoiceState
            InvoiceNumber: $InvoiceNumber
            CustomerId: $CustomerId
            Customer: $Customer
            CustomerCode: $CustomerCode
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            DueDateMin: $DueDateMin
            DueDateMax: $DueDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CompanyId: $CompanyId
        }
    ) {
        RemittanceAdviceSalesOrders {
            ...RemittanceAdviceSalesOrdersFragment
        }
    }
}

query GET_DAILY_SALES_OUT_FOR_COMPANY(
    $CompanyId: ID
    $DateMin: String
	$DateMax: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $Customer: String
    $CustomerId: ID
    $ViewAssociatedCustomers: Boolean = false
) {
    GetDailySalesOutReportForCompany(
        Filter: {
            CompanyId: $CompanyId
            DateMin: $DateMin
	        DateMax: $DateMax
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            Customer: $Customer
            CustomerId: $CustomerId
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        DailySalesOutReport
    }
}

query GET_DAILY_SALES_OUT_FOR_ORGANISATION(
    $CompanyId: ID
    $DateMin: String
	$DateMax: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CompanyIds: [ID]
    $Customer: String
    $ConversionCurrency: Float
    $OrganisationCurrencies: [OrganisationCurrencyInput]
    $CustomerId: ID
    $ViewAssociatedCustomers: Boolean = false
) {
    GetDailySalesOutReportForOrganisation(
        Filter: {
            CompanyId: $CompanyId
            DateMin: $DateMin
	        DateMax: $DateMax
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CompanyIds: $CompanyIds
            Customer: $Customer
            ConversionCurrency: $ConversionCurrency
            OrganisationCurrencies: $OrganisationCurrencies
            CustomerId: $CustomerId
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        DailySalesOutReport
    }
}

query GET_TASK_COUNT_ACTIONED_BY_USER_FOR_COMPANY(
    $CompanyId: ID
    $DisplayName: String
    $CustomerCode: String
    $InvoiceNumber: String
    $AmountValue: Float
    $AmountOperator: String
    $ActionDateMin: AWSDateTime
    $ActionDateMax: AWSDateTime
    $CreatedDateMin: AWSDateTime
    $CreatedDateMax: AWSDateTime
    $Type: Int
    $CustomerCountry: String
    $CustomerState: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $WorkflowFilters: [WorkflowFilterInput]
    $ActionedByUserId: ID
    $ActionedByEmailAddress: String
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTaskCountActionedByUserForCompany(
        Filter: { 
            CompanyId: $CompanyId
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            InvoiceNumber: $InvoiceNumber
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            ActionDateMin: $ActionDateMin
            ActionDateMax: $ActionDateMax
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            Type: $Type
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            WorkflowFilters: $WorkflowFilters
            ActionedByUserId: $ActionedByUserId
            ActionedByEmailAddress: $ActionedByEmailAddress
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TaskUserActionedCounts {
            Count
            User {
                UserId
                GivenName
                FamilyName
                Email
                CreatedDateTime
            }
            ActionedByEmailAddress
        }        
    }
}

query GET_TASK_COUNT_ACTIONED_BY_USER_FOR_ORGANISATION(
    $CompanyId: ID
    $DisplayName: String
    $CustomerCode: String
    $InvoiceNumber: String
    $AmountValue: Float
    $AmountOperator: String
    $ActionDateMin: AWSDateTime
    $ActionDateMax: AWSDateTime
    $CreatedDateMin: AWSDateTime
    $CreatedDateMax: AWSDateTime
    $Type: Int
    $CustomerCountry: String
    $CustomerState: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $WorkflowFilters: [WorkflowFilterInput]
    $ActionedByUserId: ID
    $ActionedByEmailAddress: String
    $Countries: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTaskCountActionedByUserForOrganisation(
        Filter: { 
            CompanyId: $CompanyId
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            InvoiceNumber: $InvoiceNumber
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            ActionDateMin: $ActionDateMin
            ActionDateMax: $ActionDateMax
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            Type: $Type
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            WorkflowFilters: $WorkflowFilters
            ActionedByUserId: $ActionedByUserId
            ActionedByEmailAddress: $ActionedByEmailAddress
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TaskUserActionedCounts {
            Count
            User {
                UserId
                GivenName
                FamilyName
                Email
                CreatedDateTime
            }
            ActionedByEmailAddress
        }
    }
}

query GET_TASK_COUNT_ACTIONED_BY_USER_TYPE_FOR_COMPANY(
    $CompanyId: ID
    $DisplayName: String
    $CustomerCode: String
    $InvoiceNumber: String
    $AmountValue: Float
    $AmountOperator: String
    $ActionDateMin: AWSDateTime
    $ActionDateMax: AWSDateTime
    $CreatedDateMin: AWSDateTime
    $CreatedDateMax: AWSDateTime
    $Type: Int
    $CustomerCountry: String
    $CustomerState: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $WorkflowFilters: [WorkflowFilterInput]
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTaskCountActionedByUserTypeForCompany(
        Filter: { 
            CompanyId: $CompanyId
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            InvoiceNumber: $InvoiceNumber
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            ActionDateMin: $ActionDateMin
            ActionDateMax: $ActionDateMax
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            Type: $Type
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            WorkflowFilters: $WorkflowFilters
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TaskUserTypeCounts {
            Count
            UserType
        }
    }
}

query GET_REMITTANCE_ADVICE_CREDITS(
    $RemittanceAdviceId: ID
    $CompanyId: ID
    $CreditNumber: String
    $Customer: String
    $CustomerCode: String
    $CustomerId: ID
    $CreatedDateMin: String
    $CreatedDateMax: String
    $AvailableDateMin: String
    $AvailableDateMax: String
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CreditState: String
    $CreditIds: [ID]
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $IsCloudImportType: Boolean = false
    $ExcludeCredits: Boolean
    $Type: String
    $CreatedType: String
    $Recurring: Boolean
    $ShowErrorsOnly: Boolean
    $ViewRemainingAmounts: Boolean
    $FilterAllowOverclaims: Boolean
) {
    GetRemittanceAdviceCreditsForRemittanceAdvice (
        RemittanceAdviceId: $RemittanceAdviceId
        Filter: {
            CompanyId: $CompanyId
            CreditNumber: $CreditNumber
            Customer: $Customer
            CustomerCode: $CustomerCode
            CreatedDateMin: $CreatedDateMin
            CustomerId: $CustomerId
            CreatedDateMax: $CreatedDateMax
            AvailableDateMin: $AvailableDateMin
            AvailableDateMax: $AvailableDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CreditState: $CreditState
            CreditIds: $CreditIds
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            ExcludeCredits: $ExcludeCredits
            Type: $Type
            CreatedType: $CreatedType
            Recurring: $Recurring
            ShowErrorsOnly: $ShowErrorsOnly
            ViewRemainingAmounts: $ViewRemainingAmounts
            FilterAllowOverclaims: $FilterAllowOverclaims
        }
    ) {
        RemittanceAdviceCredits {
            ...RemittanceAdviceCreditsFragment
        }
    }
}

query GET_RA_PROCESSING_CONFIG {
    GetRAProcessingConfig {
        CompanyId
        TypeHeaders
        InvoiceTypeValues
        CreditTypeValues
        RebateTypeValues
        NumberHeaders
        InvoiceNumberValues
        CreditNumberValues
        RebateNumberValues
        InvoiceNumberRemoveableValues
        CreditNumberRemoveableValues
        RebateNumberRemoveableValues
        DescriptionHeaders
        InvoiceDescriptionValues
        CreditDescriptionValues
        RebateDescriptionValues
        AmountHeaders
        CustomerCodeHeaders
        CreatedDateHeaders
        DueDateHeaders
        PaymentDateSummaryFields
        TotalPaymentSummaryFields
        AdjustmentAmount
        AdjustmentIdentifierPrepend
        AdjustmentIdentifierAppend
        AllowHighConfidence
        IgnoreItemCount
        AutoAllowOverpayment
        CreateNewCredits
        CreateNewRebates
        AutoDisregardRA
        IncludeSettledItems
        AutoAllowOverclaim
        AlternateInvoiceNumber
    }
}

query GET_RA_REBATE_MAPPINGS {
    GetRARebateMappings {
        RebateMappings{
            RebateCode
            RebateAlt 
        } 
    }
}

query GET_REMITTANCE_ADVICE_REBATE(
    $RemittanceAdviceId : ID
    $CompanyId: ID
    $CreditNumber: String
    $Customer: String
    $CustomerCode: String
    $CustomerId: ID
    $CreatedDateMin: String
    $CreatedDateMax: String
    $AvailableDateMin: String
    $AvailableDateMax: String
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CreditState: String
    $CreditIds: [ID]
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $IsCloudImportType: Boolean = false
    $ExcludeCredits: Boolean
    $CreatedType: String
    $Recurring: Boolean
    $ShowErrorsOnly: Boolean
    $ViewRemainingAmounts: Boolean
) {
    GetRemittanceAdviceRebatesForRemittanceAdvice (
        RemittanceAdviceId: $RemittanceAdviceId
        Filter: {
            CompanyId: $CompanyId
            CreditNumber: $CreditNumber
            Customer: $Customer
            CustomerCode: $CustomerCode
            CreatedDateMin: $CreatedDateMin
            CustomerId: $CustomerId
            CreatedDateMax: $CreatedDateMax
            AvailableDateMin: $AvailableDateMin
            AvailableDateMax: $AvailableDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CreditState: $CreditState
            CreditIds: $CreditIds
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            ExcludeCredits: $ExcludeCredits
            CreatedType: $CreatedType
            Recurring: $Recurring
            ShowErrorsOnly: $ShowErrorsOnly
            ViewRemainingAmounts: $ViewRemainingAmounts
        }
    ) {
        RemittanceAdviceRebates {
            ...RemittanceAdviceRebatesFragment
        }
    }
}

query GET_TASK_COUNT_ACTIONED_BY_USER_TYPE_FOR_ORGANISATION(
    $CompanyId: ID
    $DisplayName: String
    $CustomerCode: String
    $InvoiceNumber: String
    $AmountValue: Float
    $AmountOperator: String
    $ActionDateMin: AWSDateTime
    $ActionDateMax: AWSDateTime
    $CreatedDateMin: AWSDateTime
    $CreatedDateMax: AWSDateTime
    $Type: Int
    $CustomerCountry: String
    $CustomerState: String
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $WorkflowFilters: [WorkflowFilterInput]
    $Countries: [String]
    $Regions: [String]
    $CompanyIds: [ID]
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    GetTaskCountActionedByUserTypeForOrganisation(
        Filter: { 
            CompanyId: $CompanyId
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            InvoiceNumber: $InvoiceNumber
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            ActionDateMin: $ActionDateMin
            ActionDateMax: $ActionDateMax
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            Type: $Type
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            WorkflowFilters: $WorkflowFilters
            Countries: $Countries
            Regions: $Regions
            CompanyIds: $CompanyIds
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        TaskUserTypeCounts {
            Count
            UserType
        }
    }
}

query GET_SMS_CUSTOMIZATION_PROVIDER {
    GetSmsCustomizationProvider {
        CompanyId
        IsCustomizeSms
        SelectedItemId
        Items {
            BasicAuthUserName
            BasicAuthPassword
            SenderNumber
            OauthUrl
            ClientId
            ClientSecret
            Id
            Name
            Type
            Url
            ApiKey
            ApiSecret
        }
    }
}

query GET_PAYMENT_PLAN_CONFIG {
    GetPaymentPlanConfig {
        Configurations {
            ConfigId
            WorkflowId
            Frequency
            FrequencyGap
            InstalmentType
            Instalments
            InstalmentAmount
            CustomFields {
                Name
                Value
            }
            DepositAmount
            DepositPercentage
            DepositGap
            ScheduleDates
            SplitInstalmentDateRange
            NewVersion
            PayPercent
            Name
            StartTiming
            StartDelay 
            SpecificPaymentDate
            CutoffDate
            CancelAction
            IsTemplate
            IsDefault
        }
    }
}

query GET_SCHEDULED_REPORT_FOR_COMPANY( 
    $CompanyId: ID
	$CompanyIds: [ID]
	$OrganisationId: ID
	$ScheduleId: ID
	$UserId: ID
	$NextReportDateTimeMin: String
	$NextReportDateTimeMax: String
	$Status: Int
	$ReportTypeFilters: [ReportTypeFilterInput]
	$Skip: Int
	$PageSize: Int
) {
    GetReportSchedulesForCompany(
        Filter: {
            CompanyId: $CompanyId
            CompanyIds: $CompanyIds
            OrganisationId: $OrganisationId
            ScheduleId: $ScheduleId
            UserId: $UserId
            NextReportDateTimeMin: $NextReportDateTimeMin
            NextReportDateTimeMax: $NextReportDateTimeMax
            Status: $Status
            ReportTypeFilters: $ReportTypeFilters
            Skip: $Skip
            PageSize: $PageSize
        }
    ) {
        ReportSchedules {
            ScheduleId
            User {
                UserId
                GivenName
                FamilyName
            }
            Title
            Description
            Type
            ScheduleType
            ScheduleTiming1
            ScheduleTiming2
            ApplyScheduleDate
            DateFilterField
            NextReportDateTime
            NextReportLocalDateTime
            LastReportId
            LastReportDateTime
            LastReportLocalDateTime
            AlternateEmail
            ReportScheduleFilters {
                Name
                Value
            }
            LastReportHistory {
                ReportJobId
                CompanyId
                User {
                    UserId
                    GivenName
                    FamilyName
                }
                Title
                Description
                Type
                Status
                CreatedDateTime
                CompletedDateTime
                ReportAppliedFilters {
                    Name
                    Value
                }
            }
            LastReportStatus
        }
    }
}

query GET_SCHEDULED_REPORT_FOR_ORGANISATION(
    $CompanyId: ID
	$CompanyIds: [ID]
	$OrganisationId: ID
	$ScheduleId: ID
	$UserId: ID
	$NextReportDateTimeMin: String
	$NextReportDateTimeMax: String
	$Status: Int
	$ReportTypeFilters: [ReportTypeFilterInput]
	$Skip: Int
	$PageSize: Int
) {
    GetReportSchedulesForOrganisation(
        Filter: {
            CompanyId: $CompanyId
            CompanyIds: $CompanyIds
            OrganisationId: $OrganisationId
            ScheduleId: $ScheduleId
            UserId: $UserId
            NextReportDateTimeMin: $NextReportDateTimeMin
            NextReportDateTimeMax: $NextReportDateTimeMax
            Status: $Status
            ReportTypeFilters: $ReportTypeFilters
            Skip: $Skip
            PageSize: $PageSize
        }
    ) {
        ReportSchedules{
            ScheduleId
            User {
                UserId
                GivenName
                FamilyName
            }
            Title
            Description
            Type
            ScheduleType
            ScheduleTiming1
            ScheduleTiming2
            ApplyScheduleDate
            DateFilterField
            NextReportDateTime
            NextReportLocalDateTime
            LastReportId
            LastReportDateTime
            LastReportLocalDateTime
            AlternateEmail
            ReportScheduleFilters {
                Name
                Value
            }
            LastReportHistory {
                ReportJobId
                CompanyId
                User {
                    UserId
                    GivenName
                    FamilyName
                }
                Title
                Description
                Type
                Status
                CreatedDateTime
                CompletedDateTime
                ReportAppliedFilters {
                    Name
                    Value
                }
            }
            LastReportStatus
        }
    }
}

query GET_SCHEDULED_REPORT_DETAILS(
    $ScheduleId: ID
) {
    GetReportScheduleDetails(ScheduleId: $ScheduleId) {
        ScheduleId
        User {
            UserId
            GivenName
            FamilyName
        }
        Title
        Description
        Type
        ScheduleType
        ScheduleTiming1
        ScheduleTiming2
        ApplyScheduleDate
        DateFilterField
        NextReportDateTime
        NextReportLocalDateTime
        LastReportId
        LastReportDateTime
        LastReportLocalDateTime
        AlternateEmail
        Company {
            CompanyId
            Name
        }
        ReportScheduleFilters {
            Name
            Value
        }
        LastReportHistory {
            ReportJobId
            CompanyId
            User {
                UserId
                GivenName
                FamilyName
            }
            Title
            Description
            Type
            Status
            CreatedDateTime
            CompletedDateTime
            ReportAppliedFilters {
                Name
                Value
            }
        }
        LastReportStatus
    }
}

query GET_SCHEDULED_REPORT_DETAILS_FOR_ORGANISATION(
  $ScheduleId: ID
 ) {
    GetReportScheduleDetailsForOrganisation(ScheduleId: $ScheduleId) {
        ScheduleId
        User {
            UserId
            GivenName
            FamilyName
        }
        Title
        Description
        Type
        ScheduleType
        ScheduleTiming1
        ScheduleTiming2
        ApplyScheduleDate
        DateFilterField
        NextReportDateTime
        NextReportLocalDateTime
        LastReportId
        LastReportDateTime
        LastReportLocalDateTime
        AlternateEmail
        Company {
            CompanyId
            Name
        }
        ReportScheduleFilters {
            Name
            Value
        }
        LastReportHistory {
            ReportJobId
            CompanyId
            User {
                UserId
                GivenName
                FamilyName
            }
            Title
            Description
            Type
            Status
            CreatedDateTime
            CompletedDateTime
            ReportAppliedFilters {
                Name
                Value
            }
        }
        LastReportStatus
    }
}

query GET_REMITTANCE_ADVICE_SUMMARY (
    $CompanyId: ID
    $RemittanceAdviceId: ID
    $IsCloudImportType: Boolean = false
) {
    GetRemittanceAdviceSummary(
        RemittanceAdviceId: $RemittanceAdviceId
        CompanyId: $CompanyId
    ) {
        Id
        Amount
        AllocatedAmount
        Status
        ReceivedDate
        LocalReceivedDate
        PaidDate
        LocalPaidDate
        MultipleCustomer
        Customer {
            ...CustomerFragment
        }
        RemittanceAdviceInvoices {
            ...RemittanceAdviceInvoicesFragment
        }
        RemittanceAdviceCredits {
            ...RemittanceAdviceCreditsFragment
        }
        RemittanceAdviceRebates {
            Rebate {
                ...CreditFragment
            }
            AmountToAllocate
        }
        Attachments {
            ...AttachmentFragment
        }
        PaymentResource {
            Id
        }                    
        Uri
        InvoicesAllocated
        CreditsAllocated
        RebatesAllocated
        InvoicesTotalAmount
        InvoicesTotalAmountOwing
        CreditsTotalAmount
        RebatesTotalAmount
        InvoicesDiscountTotalAmount
        CreditsDiscountTotalAmount
        InvoicesErrorCount
        CreditsErrorCount
        RebatesErrorCount
        Discount
        WithOverpayments
        IsLocked
    }
}

query GET_REMITTANCE_ADVICE_CUSTOMER(
    $RemittanceAdviceId : ID
    $CompanyId: ID
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $Customer: String
    $CustomerId: ID
    $ViewAssociatedCustomers: Boolean = false
) {
    GetCustomersForRemittanceAdvice (
        RemittanceAdviceId: $RemittanceAdviceId
        Filter: {
            CompanyId: $CompanyId
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            Customer: $Customer
            CustomerId: $CustomerId
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        Customers {
            Id
            CompanyId
            DisplayName
            CustomerCode
        }
    }
}

query GET_BANK_FILE_CONFIGURATION_FOR_COMPANY {
    GetBankFileConfigurationForCompany {
        CompanyId
        BankFileIgnoreStrings {
            Format
            IgnoreStrings
        }
        BankFileMappings {
            Format
            FieldMappings {
                BankFileHeading
                PaymentHeading
            }
        }
        BankFileFormats {
            BankName
            Description
            Headings {
                Name
                Description
                Index
            }
        }
        PaymentObjectHeading {
            ObjectHeadings {
                Name
                Description
                IsRequired
            }
        }
    }
}



query GET_BANK_INSTITUTION_FOR_COMPANY_AUTOCOMPLETE_FILTER(
    $BankInstitution: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
) {
    GetPaymentsForCompany(
        Filter: {
            BankInstitution: $BankInstitution
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
        }
    ) {
        Payments {
            Id
            BankInstitution
            CompanyId
        }
    }
}

query GET_BANK_FILE_DESCRIPTORS_FOR_COMPANY(
    $CompanyId: ID
    $CustomerId: ID
	$Customer: String
	$Descriptors: [String]
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
) {
    GetCustomerBankDescriptorsForCompany (
        Filter: {
            CompanyId: $CompanyId
            CustomerId: $CustomerId
            Customer: $Customer
            Descriptors: $Descriptors
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
        }
    ) {
        CustomerBankDescriptors {
            Customer {
                Id
                CustomerCode
                CompanyId
                CompanyName
                DisplayName
                Contacts {
                    ...ContactFragment
                }
                CustomFields {
                    ...CustomFieldFragment
                }
            }
	        BankDescriptors
        }
    }
}

query GET_CUSTOMER_BANK_FILE_DESCRIPTOR_DETAILS(
	$CustomerId: ID
    $IsCloudImportType: Boolean = false
) {
    GetCustomerBankDescriptorDetails (CustomerId: $CustomerId) {
        Customer {
            ...CustomerFragment
        }
	    BankDescriptors
    }
}

query CHECK_IMPORT_JOB_STATUS_FOR_COMPANY {
    CheckImportJobStatusForCompany
}

query CHECK_TICKETS_ACTION_STATE(
    $DisplayName: String
    $CustomerCode: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $ClosedDateMin: String
    $ClosedDateMax: String
    $Status: Int
    $Action: Int
    $TicketOptionReasons: [String]
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CustomerCountry: String
    $CustomerState: String
    $LastChatDateMin: String
    $LastChatDateMax: String
    $AssignedUserId: ID
    $AssignedEmailAddress: String
    $TicketNumber: String
    $CustomerFirstLetter: [String]
    $ExcludeTickets: Boolean
    $TicketIds: [ID]
    $CustomerIds: [ID]
    $ViewAssociatedCustomers: Boolean = false
) {
    TicketsActionState(
        Filter: {
            DisplayName: $DisplayName
            CustomerCode: $CustomerCode
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            ClosedDateMin: $ClosedDateMin
            ClosedDateMax: $ClosedDateMax
            Status: $Status
            Action: $Action
            TicketOptionReasons: $TicketOptionReasons
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            LastChatDateMin: $LastChatDateMin
            LastChatDateMax: $LastChatDateMax
            AssignedUserId: $AssignedUserId
            AssignedEmailAddress: $AssignedEmailAddress
            TicketNumber: $TicketNumber
            CustomerFirstLetter: $CustomerFirstLetter
            ExcludeTickets: $ExcludeTickets
            TicketIds:$TicketIds
            CustomerIds: $CustomerIds
            ViewAssociatedCustomers: $ViewAssociatedCustomers
        }
    ) {
        ActionEnabled
        TotalTicketCount
    }
}

query GET_CASH_ALLOCATION_STATISTICS_FOR_COMPANY (
    $CompanyId: ID
    $UserIds: [ID]
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
) {
    GetCashAllocationStatisticsForCompany (
        Filter: {
            CompanyId: $CompanyId
            UserIds: $UserIds
            Ascending: $Ascending
            Skip: $Skip
	        PageSize: $PageSize
        }
    ) {
        CashAllocationStatistics {
            RemittanceProcessed
            ResourceLink
            User {
                UserId
                GivenName
                FamilyName
                Email
                CreatedDateTime
            } 
            PaymentVerified
        }
        
    }
}

query GET_CASH_ALLOCATION_STATISTICS_FOR_ORGANISATION (
    $CompanyIds: [ID]
    $UserIds: [ID]
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
) {
    GetCashAllocationStatisticsForOrganisation (
        Filter: {
            CompanyIds: $CompanyIds
            UserIds: $UserIds
            Ascending: $Ascending
            Skip: $Skip
	        PageSize: $PageSize
        }
    ) {
        CashAllocationStatistics {
            RemittanceProcessed
            ResourceLink
            User {
                UserId
                GivenName
                FamilyName
                Email
                CreatedDateTime
            } 
            PaymentVerified
        }
    }
}

query GET_REMITTANCE_ADVICE_IMPORT_STATUS(
    $RemittanceAdviceId: ID
    $CompanyId: ID
) {
    GetRemittanceAdviceLock (
        RemittanceAdviceId: $RemittanceAdviceId
        CompanyId: $CompanyId
    ) {
        IsLocked
    }
}

query GET_SALES_ORDERS_FOR_COMPANY (
    $SalesOrderState: String
    $SalesOrderNumber: String
    $CustomerId: ID
    $Customer: String
    $CustomerCode: String
    $CustomerCountry: String
    $CustomerState: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $DueDateMin: String
    $DueDateMax: String
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $InvoiceIds: [ID]
    $CompanyId: ID
    $ExcludeInvoices: Boolean
    $IsCloudImportType: Boolean = false
    $IsMultipleWorkflow: Boolean = false
    $UsingCustomerWorkflow: Boolean = false
    $IsBlocked: Boolean 
    $CustomerFirstLetter: [String]
    $InvoiceCodes: [String]
) {
    GetSalesOrdersForCompany(
        Filter: {
            SalesOrderState: $SalesOrderState
            SalesOrderNumber: $SalesOrderNumber
            CustomerId: $CustomerId
            Customer: $Customer
            CustomerCode: $CustomerCode
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            DueDateMin: $DueDateMin
            DueDateMax: $DueDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            InvoiceIds: $InvoiceIds
            CompanyId: $CompanyId
            ExcludeInvoices: $ExcludeInvoices
            IsBlocked: $IsBlocked
            CustomerFirstLetter: $CustomerFirstLetter
            InvoiceCodes: $InvoiceCodes
        }
    ) {
        SalesOrders {
            Id
            CompanyId
            Number
            InvoiceCode
            CreatedDate
            LocalCreatedDate
            DueDate
            LocalDueDate
            OriginalAmount
            AmountOwing
            State
            SettledDate
            LocalSettledDate
            Description
            Customer {
                Id
                CustomerCode @skip(if: $IsCloudImportType)
                CompanyName
                DisplayName
                Contacts {
                    ...ContactFragment
                }
                CustomFields {
                    ...CustomFieldFragment
                }
                ConversationLine {
                    ...ConversationLineCommentFragment
                }
                AgedTrialBalance {
                    TotalOverdue
                }
                IsVip
                NewInvoiceSendMode
                CurrentTask @include(if: $UsingCustomerWorkflow) {
                    Id
                    Automation
                    ActionDate
                    Type
                    Workflow {
                        StateName
                        WorkflowName @include(if: $IsMultipleWorkflow)
                    }
                    Ticket {
                        TicketOption {
                            Reason
                            CaptureMessage
                        }
                        TicketNumber
                    }
                    State
                }
                LastCommunication {
                    StateName
                    SentDateTime
                    DeliveryDetails {
                        ...DeliveryDetailFragment
                    }
                    WorkflowName @include(if: $IsMultipleWorkflow)
                }
            }
            ConversationLine {
                ...ConversationLineCommentFragment
            }
            Attachments {
                ...AttachmentFragment
            }
            IsBlocked
        }
    }
}

query GET_SALES_ORDERS_FOR_COMPANY_AUTOCOMPLETE_FILTER(
    $CompanyId: ID
    $SalesOrderState: String
    $SalesOrderNumber: String
    $Customer: String
    $CustomerCode: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $DueDateMin: String
    $DueDateMax: String
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $InvoiceIds: [ID]
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
) {
    GetSalesOrdersForCompany(
        Filter: {
            CompanyId: $CompanyId
            SalesOrderState: $SalesOrderState
            SalesOrderNumber: $SalesOrderNumber
            Customer: $Customer
            CustomerCode: $CustomerCode
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            DueDateMin: $DueDateMin
            DueDateMax: $DueDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            InvoiceIds: $InvoiceIds
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
        }
    ) {
        SalesOrders {
            Number
        }
    }
}

query GET_SALES_ORDER_DETAILS_FOR_COMPANY(
    $SalesOrderId: ID
    $IsCloudImportType: Boolean = false
) {
    GetSalesOrderDetailsForCompany(SalesOrderId: $SalesOrderId) {
        SalesOrder{
            Id
            CompanyId
            InvoiceCode
            Number
            Description
            CreatedDate
            LocalCreatedDate
            DueDate
            LocalDueDate
            OriginalAmount
            AmountOwing
            State
            SettledDate
            LocalSettledDate
            Type
            Customer {
                ...CustomerFragment
            }
            Uri
            Attachments {
                ...AttachmentFragment
            }
        }
    }
}

query GET_NUMBER_OF_INSTALMENTS_FOR_PAYMENT_PLANS(
    $PaymentPlanIds: [ID]
) {
    GetNumberOfInstalmentsForPaymentPlans(PaymentPlanIds: $PaymentPlanIds) {
        NumberOfInstalments
    }
}

query GET_PAYMENT_PLAN_CONFIG_TEMPLATE (
    $IsTemplate: Boolean
    $CompanyId: ID
) {
    GetPaymentPlanConfig(
        IsTemplate: $IsTemplate
        CompanyId: $CompanyId
    ) {
        Configurations {
            ConfigId
            InstalmentType
            Instalments
            ScheduleDates
            PayPercent
            SplitInstalmentDateRange
            Name
            CutoffDate
            StartDelay
            FrequencyGap
            SpecificPaymentDate
            StartTiming
        }
    }
}

query GET_INVOICES_NO_PAYMENT_PLAN_BY_INVOICE_FILTER (
    $InvoiceState: String
    $InvoiceNumber: String
    $CustomerId: ID
    $CustomerIds: [ID]
    $Customer: String
    $CustomerCode: String
    $CustomerCountry: String
    $CustomerState: String
    $CreatedDateMin: String
    $CreatedDateMax: String
    $DueDateMin: String
    $DueDateMax: String
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $InvoiceIds: [ID]
    $CompanyId: ID
    $ExcludeInvoices: Boolean
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $IsBlocked: Boolean
    $CustomerFirstLetter: [String]
    $IsCloudImportType: Boolean = false
) {
    GetInvoicesNoPaymentPlanByInvoiceFilter(
        Filter: {
            InvoiceState: $InvoiceState
            InvoiceNumber: $InvoiceNumber
            CustomerId: $CustomerId
            CustomerIds: $CustomerIds
            Customer: $Customer
            CustomerCode: $CustomerCode
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CreatedDateMin: $CreatedDateMin
            CreatedDateMax: $CreatedDateMax
            DueDateMin: $DueDateMin
            DueDateMax: $DueDateMax
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            InvoiceIds: $InvoiceIds
            CompanyId: $CompanyId
            ExcludeInvoices: $ExcludeInvoices
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            IsBlocked: $IsBlocked
            CustomerFirstLetter: $CustomerFirstLetter
        }
    ) {
        Invoices {
            Id
            CompanyId
            Number
            InvoiceCode
            CreatedDate
            LocalCreatedDate
            DueDate
            LocalDueDate
            OriginalAmount
            AmountOwing
            State
            SettledDate
            LocalSettledDate
            AgedTrialBalanceFromCreate {
                ...AgedTrialBalanceFromCreateFragment
            }
            AgedTrialBalanceFromDue {
                ...AgedTrialBalanceFromDueFragment
            }
            Customer {
                Id
                CustomerCode @skip(if: $IsCloudImportType)
                DisplayName
                CustomFields {
                    ...CustomFieldFragment
                }
                ConversationLine {
                    ...ConversationLineCommentFragment
                }
                IsVip
            }
            CustomFields {
                ...CustomFieldFragment
            }
            IsBlocked
            PaymentPlan {
                Number
            }
        }
    }
}

query GET_INVOICES_NO_PAYMENT_PLAN_BY_CUSTOMER_FILTER (
    $CompanyId: ID
    $Customer: String
    $CustomerIds: [ID]
    $InclusiveContact: Boolean
    $Contact: Int
    $ATBType: Int
    $AmountType: String
    $AmountValue: String
    $AmountOperator: String
    $SortField: String
    $Ascending: Boolean
    $Skip: Int
    $PageSize: Int
    $CustomFieldFilters: String
    $CustomFieldMultipleValuesFilters: String
    $CustomFieldSort: String
    $IsCloudImportType: Boolean = false
    $IsVip: Boolean
    $CustomerCountry: String
    $CustomerState: String
    $CustomerFirstLetter: [String]
) {
    GetInvoicesNoPaymentPlanByCustomerFilter(
        Filter: {
            CompanyId: $CompanyId
            Customer: $Customer
            CustomerIds : $CustomerIds
            InclusiveContact: $InclusiveContact
            Contact: $Contact
            ATBType: $ATBType
            AmountType: $AmountType
            AmountValue: $AmountValue
            AmountOperator: $AmountOperator
            SortField: $SortField
            Ascending: $Ascending
            Skip: $Skip
            PageSize: $PageSize
            CustomFieldFilters: $CustomFieldFilters
            CustomFieldMultipleValuesFilters: $CustomFieldMultipleValuesFilters
            CustomFieldSort: $CustomFieldSort
            IsVip: $IsVip
            CustomerCountry: $CustomerCountry
            CustomerState: $CustomerState
            CustomerFirstLetter: $CustomerFirstLetter
        }
    ) {
        Invoices {
            Id
            CompanyId
            Number
            InvoiceCode
            CreatedDate
            LocalCreatedDate
            DueDate
            LocalDueDate
            OriginalAmount
            AmountOwing
            State
            SettledDate
            LocalSettledDate
            AgedTrialBalanceFromCreate {
                ...AgedTrialBalanceFromCreateFragment
            }
            AgedTrialBalanceFromDue {
                ...AgedTrialBalanceFromDueFragment
            }
            Customer {
                Id
                CustomerCode @skip(if: $IsCloudImportType)
                DisplayName
                CustomFields {
                    ...CustomFieldFragment
                }
                ConversationLine {
                    ...ConversationLineCommentFragment
                }
                IsVip
            }
            CustomFields {
                ...CustomFieldFragment
            }
            IsBlocked
            PaymentPlan {
                Number
            }
        }
    }
}

query GET_MYOB_CONFIGURATION_FOR_IMPORT {
    GetMYOBConfigurationForImport {
        CompanyId
        ConnectionId
        TenantName
        MYOBUser {
            UserId
            UserName
            MYOBCompanies {
                MYOBCompanyId
	            Name
            }
        }
    }
}

query GET_MYOB_COMPANY_SETTINGS_FOR_IMPORT {
    GetMYOBSettingsForCompany {
        MYOBCompanySettings
        {
            IODMName
            MYOBName
        }
    }
}

query GET_REMITTANCE_ADVICE_PROCESSOR_REPORT(
    $RemittanceAdviceId: ID
    $CompanyId: ID
) {
    GetRemittanceAdviceProcessorReport(
        RemittanceAdviceId: $RemittanceAdviceId
        CompanyId: $CompanyId
    ) {
        RemittanceAdviceProcessorReports {
            RemittanceAdviceId
            Type
            Value
        }
    }
}

query GET_PBI_CONFIGURATION {
    GetPBIConfiguration {
        CompanyConfigBehaviourInsights {
            WorkflowId
	        State
        }
        ComparisonPeriod
        EvaluationScheduleType
        EvaluationTiming
        EvaluationTimingDay
    }
}

query GET_COMPANY_WEBHOOKS {
    GetCompanyWebhooks {
        CompanyId
        CreatedAt
        UpdatedAt
        IsHMACEnabled
        IsAESEnabled
        WebhooksInformation {
            BaseUrl
            Scope
            TriggeredBy
        }
    }
}

query GET_QUESTION_ANSWER_CONFIGURATION_FOR_COMPANY {
    GetQuestionAnswerConfigurationForCompany {
        QuestionAnswerItems {
            Question
	        Answer
        }
    }
}

query GET_CONVERA_CREDENTIALS_FOR_COMPANY {
    GetConveraCredentialsForCompany {
        ClientId
        MerchantId
        MerchantSecret
        PaymentTrackingMerchantId
        PaymentTrackingMerchantSecret
        Url
    }
}